// ============================================================
// DADOS DE SEED - GERADO AUTOMATICAMENTE
// 419 ordens de serviço (Jan-Out 2026) + 12 clientes + transações
// NÃO EDITAR MANUALMENTE
// ============================================================

import { Customer, Order, FinancialTransaction } from '../types';
import { OrderStatus, PaymentStatus } from '../types';

export const SEED_CUSTOMERS: Customer[] = [
  {
    "id": "demo-cust-1",
    "name": "Ana Clara Albuquerque",
    "phone": "(11) 98765-4321",
    "email": "ana.clara@email.com",
    "cpf": "123.456.789-00",
    "rg": "12.345.678-9",
    "birthDate": "1992-05-18",
    "gender": "F",
    "profession": "Arquiteta",
    "address": {
      "zipCode": "01310-100",
      "street": "Av. Paulista",
      "number": "1000",
      "complement": "Apto 42",
      "neighborhood": "Bela Vista",
      "city": "São Paulo",
      "state": "SP"
    },
    "creditLimit": 2500,
    "creditStatus": "APPROVED",
    "notes": "Cliente VIP. Prefere armações em acetato leve e lentes fotossensíveis.",
    "prescriptions": [
      {
        "id": "demo-presc-1",
        "date": "2026-04-10",
        "doctorName": "Dr. Roberto Vasconcelos (CRM 45890-SP)",
        "od": {
          "spherical": "-2.50",
          "cylinder": "-0.75",
          "axis": "180",
          "add": "+1.50",
          "pd": "31",
          "height": "18"
        },
        "oe": {
          "spherical": "-2.25",
          "cylinder": "-0.50",
          "axis": "175",
          "add": "+1.50",
          "pd": "31",
          "height": "18"
        },
        "notes": "Uso contínuo para trabalho no computador. Recomendado filtro de luz azul."
      }
    ]
  },
  {
    "id": "demo-cust-2",
    "name": "Carlos Eduardo Oliveira",
    "phone": "(11) 97654-3210",
    "email": "carlos.oliveira@empresa.com",
    "cpf": "234.567.890-11",
    "rg": "23.456.789-0",
    "birthDate": "1985-10-24",
    "gender": "M",
    "profession": "Empresário",
    "address": {
      "zipCode": "04538-133",
      "street": "Rua Funchal",
      "number": "418",
      "neighborhood": "Vila Olímpia",
      "city": "São Paulo",
      "state": "SP"
    },
    "creditLimit": 3000,
    "creditStatus": "APPROVED",
    "notes": "Optou por lentes multifocais digitais personalizadas.",
    "prescriptions": []
  },
  {
    "id": "demo-cust-3",
    "name": "Beatriz Martins Santos",
    "phone": "(11) 96543-2109",
    "email": "beatriz.santos@gmail.com",
    "cpf": "345.678.901-22",
    "rg": "34.567.890-1",
    "birthDate": "1998-10-05",
    "gender": "F",
    "profession": "Advogada",
    "address": {
      "zipCode": "01414-001",
      "street": "Rua Bela Cintra",
      "number": "1200",
      "neighborhood": "Consolação",
      "city": "São Paulo",
      "state": "SP"
    },
    "creditLimit": 1800,
    "creditStatus": "APPROVED",
    "notes": "Primeira vez na ótica. Gostou das marcas Ray-Ban e Vogue.",
    "prescriptions": []
  },
  {
    "id": "demo-cust-4",
    "name": "Fernando Augusto Lima",
    "phone": "(11) 95432-1098",
    "email": "fernando.lima@hotmail.com",
    "cpf": "456.789.012-33",
    "rg": "45.678.901-2",
    "birthDate": "1975-03-12",
    "gender": "M",
    "profession": "Médico Cardiologista",
    "address": {
      "zipCode": "05423-040",
      "street": "Rua Teodoro Sampaio",
      "number": "744",
      "neighborhood": "Pinheiros",
      "city": "São Paulo",
      "state": "SP"
    },
    "creditLimit": 5000,
    "creditStatus": "APPROVED",
    "notes": "Usa grau alto. Prefere lentes super finas 1.74. VIP indicado pela Ana Clara.",
    "prescriptions": [
      {
        "id": "demo-presc-4",
        "date": "2026-02-20",
        "doctorName": "Dra. Fernanda Óptica (CRO 12345-SP)",
        "od": {
          "spherical": "-5.50",
          "cylinder": "-1.25",
          "axis": "90",
          "add": "+2.00",
          "pd": "33",
          "height": "20"
        },
        "oe": {
          "spherical": "-5.75",
          "cylinder": "-1.00",
          "axis": "85",
          "add": "+2.00",
          "pd": "33",
          "height": "20"
        },
        "notes": "Grau alto - recomendado lente 1.74 antirreflexo premium."
      }
    ]
  },
  {
    "id": "demo-cust-5",
    "name": "Juliana Ferreira Costa",
    "phone": "(11) 94321-0987",
    "email": "juliana.costa@gmail.com",
    "cpf": "567.890.123-44",
    "birthDate": "1989-07-22",
    "gender": "F",
    "profession": "Professora",
    "address": {
      "zipCode": "03022-000",
      "street": "Av. Celso Garcia",
      "number": "3200",
      "neighborhood": "Tatuapé",
      "city": "São Paulo",
      "state": "SP"
    },
    "creditLimit": 1500,
    "creditStatus": "APPROVED",
    "notes": "Compra anualmente. Prefere armações coloridas.",
    "prescriptions": []
  },
  {
    "id": "demo-cust-6",
    "name": "Roberto Souza Mendes",
    "phone": "(11) 93210-9876",
    "email": "roberto.mendes@empresa.com",
    "cpf": "678.901.234-55",
    "birthDate": "1965-01-30",
    "gender": "M",
    "profession": "Engenheiro Civil",
    "address": {
      "zipCode": "04726-001",
      "street": "Rua Vergueiro",
      "number": "5109",
      "neighborhood": "Jabaquara",
      "city": "São Paulo",
      "state": "SP"
    },
    "creditLimit": 4000,
    "creditStatus": "APPROVED",
    "notes": "Aposentado. Vem com a esposa. Usa bifocal.",
    "prescriptions": []
  },
  {
    "id": "demo-cust-7",
    "name": "Patricia Alves Nunes",
    "phone": "(11) 92109-8765",
    "email": "patricia.nunes@outlook.com",
    "cpf": "789.012.345-66",
    "birthDate": "1995-11-08",
    "gender": "F",
    "profession": "Designer Gráfica",
    "address": {
      "zipCode": "01224-010",
      "street": "Rua Augusta",
      "number": "2200",
      "complement": "Sala 45",
      "neighborhood": "Consolação",
      "city": "São Paulo",
      "state": "SP"
    },
    "creditLimit": 2000,
    "creditStatus": "APPROVED",
    "notes": "Trabalha em design - precisa de filtro luz azul. Muito exigente com estética.",
    "prescriptions": []
  },
  {
    "id": "demo-cust-8",
    "name": "Marcos Antonio Barbosa",
    "phone": "(11) 91098-7654",
    "email": "marcos.barbosa@gmail.com",
    "cpf": "890.123.456-77",
    "birthDate": "1980-04-15",
    "gender": "M",
    "profession": "Contador",
    "address": {
      "zipCode": "01045-100",
      "street": "Rua Boa Vista",
      "number": "356",
      "neighborhood": "Centro",
      "city": "São Paulo",
      "state": "SP"
    },
    "creditLimit": 2200,
    "creditStatus": "APPROVED",
    "notes": "Cliente antigo. Traz família. Compra sempre 2 pares.",
    "prescriptions": []
  },
  {
    "id": "demo-cust-9",
    "name": "Camila Torres Rodrigues",
    "phone": "(11) 90987-6543",
    "email": "camila.torres@gmail.com",
    "cpf": "901.234.567-88",
    "birthDate": "2001-08-03",
    "gender": "F",
    "profession": "Estudante Universitária",
    "address": {
      "zipCode": "05508-010",
      "street": "Av. Prof. Luciano Gualberto",
      "number": "1000",
      "neighborhood": "Butantã",
      "city": "São Paulo",
      "state": "SP"
    },
    "creditLimit": 800,
    "creditStatus": "APPROVED",
    "notes": "Jovem. Gosta de armações trendy. Primeira compra de grau.",
    "prescriptions": []
  },
  {
    "id": "demo-cust-10",
    "name": "Diego Henrique Pereira",
    "phone": "(11) 99876-5432",
    "email": "diego.pereira@gmail.com",
    "cpf": "012.345.678-99",
    "birthDate": "1993-12-27",
    "gender": "M",
    "profession": "Analista de TI",
    "address": {
      "zipCode": "06700-000",
      "street": "Rua das Pitangueiras",
      "number": "200",
      "neighborhood": "Cotia",
      "city": "Cotia",
      "state": "SP"
    },
    "creditLimit": 2500,
    "creditStatus": "APPROVED",
    "notes": "Trabalha muito no computador. Muito interessado em filtro azul e anti-UV.",
    "prescriptions": []
  },
  {
    "id": "demo-cust-11",
    "name": "Larissa Monteiro Campos",
    "phone": "(11) 98765-1234",
    "email": "larissa.campos@hotmail.com",
    "cpf": "111.222.333-44",
    "birthDate": "1987-06-19",
    "gender": "F",
    "profession": "Nutricionista",
    "address": {
      "zipCode": "04010-010",
      "street": "Rua Domingos de Morais",
      "number": "1450",
      "neighborhood": "Vila Mariana",
      "city": "São Paulo",
      "state": "SP"
    },
    "creditLimit": 1800,
    "creditStatus": "APPROVED",
    "notes": "Aniversário mês que vem! Mandar mensagem.",
    "prescriptions": []
  },
  {
    "id": "demo-cust-12",
    "name": "Rafael Carvalho Gomes",
    "phone": "(11) 97654-2345",
    "email": "rafael.gomes@empresa.com.br",
    "cpf": "222.333.444-55",
    "birthDate": "1972-09-05",
    "gender": "M",
    "profession": "Diretor Comercial",
    "address": {
      "zipCode": "01452-000",
      "street": "Rua Haddock Lobo",
      "number": "595",
      "neighborhood": "Cerqueira César",
      "city": "São Paulo",
      "state": "SP"
    },
    "creditLimit": 8000,
    "creditStatus": "APPROVED",
    "notes": "Executivo. Compra lentes importadas. Alto ticket médio.",
    "prescriptions": []
  }
];

export const SEED_ORDERS: Order[] = ([
  {
    "id": "OS-1001",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-01-06",
    "status": "Entregue",
    "totalAmount": 1951,
    "paidAmount": 1951,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-01-16"
  },
  {
    "id": "OS-1002",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-01-06",
    "status": "Entregue",
    "totalAmount": 2755,
    "paidAmount": 2181,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-01-24"
  },
  {
    "id": "OS-1003",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-01-07",
    "status": "Entregue",
    "totalAmount": 1884,
    "paidAmount": 1509,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-01-18"
  },
  {
    "id": "OS-1004",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-01-07",
    "status": "Entregue",
    "totalAmount": 2003,
    "paidAmount": 1031,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-01-23"
  },
  {
    "id": "OS-1005",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-01-08",
    "status": "Entregue",
    "totalAmount": 2138,
    "paidAmount": 2138,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-01-26"
  },
  {
    "id": "OS-1006",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-01-09",
    "status": "Entregue",
    "totalAmount": 631,
    "paidAmount": 494,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-01-18"
  },
  {
    "id": "OS-1007",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-01-09",
    "status": "Entregue",
    "totalAmount": 1724,
    "paidAmount": 1724,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-01-23"
  },
  {
    "id": "OS-1008",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-01-10",
    "status": "Entregue",
    "totalAmount": 1256,
    "paidAmount": 1256,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-01-21"
  },
  {
    "id": "OS-1009",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-01-10",
    "status": "Entregue",
    "totalAmount": 1203,
    "paidAmount": 1203,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-01-22"
  },
  {
    "id": "OS-1010",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-01-11",
    "status": "Entregue",
    "totalAmount": 1675,
    "paidAmount": 1675,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-01-24"
  },
  {
    "id": "OS-1011",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-01-13",
    "status": "Entregue",
    "totalAmount": 1954,
    "paidAmount": 1954,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-02-02"
  },
  {
    "id": "OS-1012",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-01-13",
    "status": "Entregue",
    "totalAmount": 610,
    "paidAmount": 610,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-01-20"
  },
  {
    "id": "OS-1013",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-01-14",
    "status": "Entregue",
    "totalAmount": 2068,
    "paidAmount": 1871,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-01-29"
  },
  {
    "id": "OS-1014",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-01-14",
    "status": "Entregue",
    "totalAmount": 986,
    "paidAmount": 815,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-01-23"
  },
  {
    "id": "OS-1015",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-01-15",
    "status": "Entregue",
    "totalAmount": 2625,
    "paidAmount": 2119,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-01-28"
  },
  {
    "id": "OS-1016",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-01-16",
    "status": "Entregue",
    "totalAmount": 564,
    "paidAmount": 564,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-01-31"
  },
  {
    "id": "OS-1017",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-01-16",
    "status": "Entregue",
    "totalAmount": 1663,
    "paidAmount": 1663,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-01-27"
  },
  {
    "id": "OS-1018",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-01-17",
    "status": "Entregue",
    "totalAmount": 835,
    "paidAmount": 835,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-01-30"
  },
  {
    "id": "OS-1019",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-01-17",
    "status": "Entregue",
    "totalAmount": 1578,
    "paidAmount": 1578,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-01-26"
  },
  {
    "id": "OS-1020",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-01-18",
    "status": "Entregue",
    "totalAmount": 476,
    "paidAmount": 293,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-02-07"
  },
  {
    "id": "OS-1021",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-01-20",
    "status": "Entregue",
    "totalAmount": 2101,
    "paidAmount": 2101,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-01-31"
  },
  {
    "id": "OS-1022",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-01-20",
    "status": "Entregue",
    "totalAmount": 1887,
    "paidAmount": 1887,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-01-31"
  },
  {
    "id": "OS-1023",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-01-21",
    "status": "Entregue",
    "totalAmount": 1238,
    "paidAmount": 1215,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-02-01"
  },
  {
    "id": "OS-1024",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-01-21",
    "status": "Entregue",
    "totalAmount": 2154,
    "paidAmount": 2154,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-02-05"
  },
  {
    "id": "OS-1025",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-01-22",
    "status": "Entregue",
    "totalAmount": 2700,
    "paidAmount": 2700,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-02-03"
  },
  {
    "id": "OS-1026",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-01-23",
    "status": "Entregue",
    "totalAmount": 1883,
    "paidAmount": 1883,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-02-02"
  },
  {
    "id": "OS-1027",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-01-23",
    "status": "Entregue",
    "totalAmount": 2276,
    "paidAmount": 2276,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-02-13"
  },
  {
    "id": "OS-1028",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-01-24",
    "status": "Entregue",
    "totalAmount": 630,
    "paidAmount": 630,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-02-03"
  },
  {
    "id": "OS-1029",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-01-24",
    "status": "Entregue",
    "totalAmount": 2634,
    "paidAmount": 2634,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-02-10"
  },
  {
    "id": "OS-1030",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-01-25",
    "status": "Entregue",
    "totalAmount": 1374,
    "paidAmount": 1058,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-02-06"
  },
  {
    "id": "OS-1031",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-01-27",
    "status": "Entregue",
    "totalAmount": 1926,
    "paidAmount": 1926,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-02-12"
  },
  {
    "id": "OS-1032",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-01-27",
    "status": "Entregue",
    "totalAmount": 2747,
    "paidAmount": 2747,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-02-07"
  },
  {
    "id": "OS-1033",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-01-28",
    "status": "Entregue",
    "totalAmount": 2224,
    "paidAmount": 2224,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-02-08"
  },
  {
    "id": "OS-1034",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-01-28",
    "status": "Entregue",
    "totalAmount": 1416,
    "paidAmount": 1416,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-02-14"
  },
  {
    "id": "OS-1035",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-01-29",
    "status": "Entregue",
    "totalAmount": 2409,
    "paidAmount": 2409,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-02-10"
  },
  {
    "id": "OS-1036",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-01-30",
    "status": "Entregue",
    "totalAmount": 2165,
    "paidAmount": 2165,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-02-19"
  },
  {
    "id": "OS-1037",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-01-30",
    "status": "Entregue",
    "totalAmount": 1378,
    "paidAmount": 1378,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-02-09"
  },
  {
    "id": "OS-1038",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-01-31",
    "status": "Entregue",
    "totalAmount": 908,
    "paidAmount": 668,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-02-11"
  },
  {
    "id": "OS-1039",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-01-31",
    "status": "Entregue",
    "totalAmount": 1451,
    "paidAmount": 1451,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-02-10"
  },
  {
    "id": "OS-1040",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-02-01",
    "status": "Entregue",
    "totalAmount": 2559,
    "paidAmount": 2559,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-02-09"
  },
  {
    "id": "OS-1041",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-02-03",
    "status": "Entregue",
    "totalAmount": 851,
    "paidAmount": 851,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-02-16"
  },
  {
    "id": "OS-1042",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-02-03",
    "status": "Entregue",
    "totalAmount": 614,
    "paidAmount": 614,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-02-23"
  },
  {
    "id": "OS-1043",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-02-04",
    "status": "Entregue",
    "totalAmount": 1918,
    "paidAmount": 1918,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-02-14"
  },
  {
    "id": "OS-1044",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-02-04",
    "status": "Entregue",
    "totalAmount": 2075,
    "paidAmount": 963,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-02-20"
  },
  {
    "id": "OS-1045",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-02-05",
    "status": "Entregue",
    "totalAmount": 2611,
    "paidAmount": 2611,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-02-26"
  },
  {
    "id": "OS-1046",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-02-06",
    "status": "Entregue",
    "totalAmount": 1881,
    "paidAmount": 1881,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-02-18"
  },
  {
    "id": "OS-1047",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-02-06",
    "status": "Entregue",
    "totalAmount": 1958,
    "paidAmount": 1958,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-02-13"
  },
  {
    "id": "OS-1048",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-02-07",
    "status": "Entregue",
    "totalAmount": 519,
    "paidAmount": 519,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-02-18"
  },
  {
    "id": "OS-1049",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-02-07",
    "status": "Entregue",
    "totalAmount": 2443,
    "paidAmount": 2443,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-02-16"
  },
  {
    "id": "OS-1050",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-02-08",
    "status": "Entregue",
    "totalAmount": 1266,
    "paidAmount": 664,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-02-28"
  },
  {
    "id": "OS-1051",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-02-10",
    "status": "Entregue",
    "totalAmount": 1169,
    "paidAmount": 1169,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-02-24"
  },
  {
    "id": "OS-1052",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-02-10",
    "status": "Entregue",
    "totalAmount": 960,
    "paidAmount": 736,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-02-18"
  },
  {
    "id": "OS-1053",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-02-11",
    "status": "Entregue",
    "totalAmount": 2502,
    "paidAmount": 2502,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-02-23"
  },
  {
    "id": "OS-1054",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-02-11",
    "status": "Entregue",
    "totalAmount": 1590,
    "paidAmount": 1590,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-02-22"
  },
  {
    "id": "OS-1055",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-02-12",
    "status": "Entregue",
    "totalAmount": 1023,
    "paidAmount": 1023,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-03-03"
  },
  {
    "id": "OS-1056",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-02-13",
    "status": "Entregue",
    "totalAmount": 2542,
    "paidAmount": 1158,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-02-27"
  },
  {
    "id": "OS-1057",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-02-13",
    "status": "Entregue",
    "totalAmount": 2120,
    "paidAmount": 2120,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-02-28"
  },
  {
    "id": "OS-1058",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-02-14",
    "status": "Entregue",
    "totalAmount": 1814,
    "paidAmount": 1814,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-03-06"
  },
  {
    "id": "OS-1059",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-02-14",
    "status": "Entregue",
    "totalAmount": 2092,
    "paidAmount": 2092,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-02-25"
  },
  {
    "id": "OS-1060",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-02-15",
    "status": "Entregue",
    "totalAmount": 878,
    "paidAmount": 878,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-03-04"
  },
  {
    "id": "OS-1061",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-02-17",
    "status": "Entregue",
    "totalAmount": 1098,
    "paidAmount": 894,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-03-05"
  },
  {
    "id": "OS-1062",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-02-17",
    "status": "Entregue",
    "totalAmount": 1607,
    "paidAmount": 969,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-02-27"
  },
  {
    "id": "OS-1063",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-02-18",
    "status": "Entregue",
    "totalAmount": 725,
    "paidAmount": 725,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-03-05"
  },
  {
    "id": "OS-1064",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-02-18",
    "status": "Entregue",
    "totalAmount": 2662,
    "paidAmount": 2662,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-03-06"
  },
  {
    "id": "OS-1065",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-02-19",
    "status": "Entregue",
    "totalAmount": 2149,
    "paidAmount": 2149,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-03-05"
  },
  {
    "id": "OS-1066",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-02-20",
    "status": "Entregue",
    "totalAmount": 2156,
    "paidAmount": 2156,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-03-13"
  },
  {
    "id": "OS-1067",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-02-20",
    "status": "Entregue",
    "totalAmount": 450,
    "paidAmount": 450,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-03-02"
  },
  {
    "id": "OS-1068",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-02-21",
    "status": "Entregue",
    "totalAmount": 541,
    "paidAmount": 541,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-03-06"
  },
  {
    "id": "OS-1069",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-02-21",
    "status": "Entregue",
    "totalAmount": 2531,
    "paidAmount": 2531,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-03-08"
  },
  {
    "id": "OS-1070",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-02-22",
    "status": "Entregue",
    "totalAmount": 863,
    "paidAmount": 863,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-03-09"
  },
  {
    "id": "OS-1071",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-02-24",
    "status": "Entregue",
    "totalAmount": 2021,
    "paidAmount": 2021,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-03-14"
  },
  {
    "id": "OS-1072",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-02-24",
    "status": "Entregue",
    "totalAmount": 889,
    "paidAmount": 583,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-03-12"
  },
  {
    "id": "OS-1073",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-02-25",
    "status": "Entregue",
    "totalAmount": 2512,
    "paidAmount": 2512,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-03-18"
  },
  {
    "id": "OS-1074",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-02-25",
    "status": "Entregue",
    "totalAmount": 2432,
    "paidAmount": 2432,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-03-18"
  },
  {
    "id": "OS-1075",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-02-26",
    "status": "Entregue",
    "totalAmount": 1762,
    "paidAmount": 1607,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-03-05"
  },
  {
    "id": "OS-1076",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-02-27",
    "status": "Entregue",
    "totalAmount": 1533,
    "paidAmount": 1533,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-03-10"
  },
  {
    "id": "OS-1077",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-02-27",
    "status": "Entregue",
    "totalAmount": 2705,
    "paidAmount": 1585,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-03-08"
  },
  {
    "id": "OS-1078",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-02-28",
    "status": "Entregue",
    "totalAmount": 1761,
    "paidAmount": 1761,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-03-20"
  },
  {
    "id": "OS-1079",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-02-28",
    "status": "Entregue",
    "totalAmount": 2043,
    "paidAmount": 2043,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-03-16"
  },
  {
    "id": "OS-1080",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-03-01",
    "status": "Entregue",
    "totalAmount": 785,
    "paidAmount": 785,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-03-18"
  },
  {
    "id": "OS-1081",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-03-03",
    "status": "Entregue",
    "totalAmount": 903,
    "paidAmount": 903,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-03-22"
  },
  {
    "id": "OS-1082",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-03-03",
    "status": "Entregue",
    "totalAmount": 602,
    "paidAmount": 602,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-03-20"
  },
  {
    "id": "OS-1083",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-03-04",
    "status": "Entregue",
    "totalAmount": 2428,
    "paidAmount": 1620,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-03-20"
  },
  {
    "id": "OS-1084",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-03-04",
    "status": "Entregue",
    "totalAmount": 1959,
    "paidAmount": 1959,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-03-14"
  },
  {
    "id": "OS-1085",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-03-05",
    "status": "Entregue",
    "totalAmount": 1883,
    "paidAmount": 1883,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-03-22"
  },
  {
    "id": "OS-1086",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-03-06",
    "status": "Entregue",
    "totalAmount": 1061,
    "paidAmount": 1061,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-03-27"
  },
  {
    "id": "OS-1087",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-03-06",
    "status": "Entregue",
    "totalAmount": 461,
    "paidAmount": 177,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-03-21"
  },
  {
    "id": "OS-1088",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-03-07",
    "status": "Entregue",
    "totalAmount": 993,
    "paidAmount": 474,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-03-20"
  },
  {
    "id": "OS-1089",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-03-07",
    "status": "Entregue",
    "totalAmount": 1247,
    "paidAmount": 693,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-03-27"
  },
  {
    "id": "OS-1090",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-03-08",
    "status": "Entregue",
    "totalAmount": 2355,
    "paidAmount": 1436,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-03-29"
  },
  {
    "id": "OS-1091",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-03-10",
    "status": "Entregue",
    "totalAmount": 1989,
    "paidAmount": 1989,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-03-27"
  },
  {
    "id": "OS-1092",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-03-10",
    "status": "Entregue",
    "totalAmount": 1664,
    "paidAmount": 1664,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-03-25"
  },
  {
    "id": "OS-1093",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-03-11",
    "status": "Entregue",
    "totalAmount": 2687,
    "paidAmount": 2687,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-03-20"
  },
  {
    "id": "OS-1094",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-03-11",
    "status": "Entregue",
    "totalAmount": 2298,
    "paidAmount": 1733,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-03-18"
  },
  {
    "id": "OS-1095",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-03-12",
    "status": "Entregue",
    "totalAmount": 1224,
    "paidAmount": 1224,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-03-19"
  },
  {
    "id": "OS-1096",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-03-13",
    "status": "Entregue",
    "totalAmount": 2472,
    "paidAmount": 2472,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-03-26"
  },
  {
    "id": "OS-1097",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-03-13",
    "status": "Entregue",
    "totalAmount": 1719,
    "paidAmount": 1646,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-04-01"
  },
  {
    "id": "OS-1098",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-03-14",
    "status": "Entregue",
    "totalAmount": 2037,
    "paidAmount": 2037,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-04-01"
  },
  {
    "id": "OS-1099",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-03-14",
    "status": "Entregue",
    "totalAmount": 1684,
    "paidAmount": 1684,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-03-31"
  },
  {
    "id": "OS-1100",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-03-15",
    "status": "Entregue",
    "totalAmount": 861,
    "paidAmount": 441,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-03-24"
  },
  {
    "id": "OS-1101",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-03-17",
    "status": "Entregue",
    "totalAmount": 1996,
    "paidAmount": 1996,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-04-01"
  },
  {
    "id": "OS-1102",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-03-17",
    "status": "Entregue",
    "totalAmount": 1190,
    "paidAmount": 1165,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-04-04"
  },
  {
    "id": "OS-1103",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-03-18",
    "status": "Entregue",
    "totalAmount": 1951,
    "paidAmount": 1951,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-04-01"
  },
  {
    "id": "OS-1104",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-03-18",
    "status": "Entregue",
    "totalAmount": 2083,
    "paidAmount": 2083,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-04-01"
  },
  {
    "id": "OS-1105",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-03-19",
    "status": "Entregue",
    "totalAmount": 2021,
    "paidAmount": 1408,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-04-03"
  },
  {
    "id": "OS-1106",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-03-20",
    "status": "Entregue",
    "totalAmount": 1951,
    "paidAmount": 1951,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-03-28"
  },
  {
    "id": "OS-1107",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-03-20",
    "status": "Entregue",
    "totalAmount": 1663,
    "paidAmount": 1663,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-04-10"
  },
  {
    "id": "OS-1108",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-03-21",
    "status": "Entregue",
    "totalAmount": 788,
    "paidAmount": 788,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-03-29"
  },
  {
    "id": "OS-1109",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-03-21",
    "status": "Entregue",
    "totalAmount": 1106,
    "paidAmount": 1106,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-04-04"
  },
  {
    "id": "OS-1110",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-03-22",
    "status": "Entregue",
    "totalAmount": 2452,
    "paidAmount": 2452,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-04-02"
  },
  {
    "id": "OS-1111",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-03-24",
    "status": "Entregue",
    "totalAmount": 647,
    "paidAmount": 282,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-04-03"
  },
  {
    "id": "OS-1112",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-03-24",
    "status": "Entregue",
    "totalAmount": 944,
    "paidAmount": 944,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-04-10"
  },
  {
    "id": "OS-1113",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-03-25",
    "status": "Entregue",
    "totalAmount": 541,
    "paidAmount": 314,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-04-10"
  },
  {
    "id": "OS-1114",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-03-25",
    "status": "Entregue",
    "totalAmount": 2310,
    "paidAmount": 2310,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-04-13"
  },
  {
    "id": "OS-1115",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-03-26",
    "status": "Entregue",
    "totalAmount": 1324,
    "paidAmount": 1324,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-04-11"
  },
  {
    "id": "OS-1116",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-03-27",
    "status": "Entregue",
    "totalAmount": 2471,
    "paidAmount": 2471,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-04-16"
  },
  {
    "id": "OS-1117",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-03-27",
    "status": "Entregue",
    "totalAmount": 1790,
    "paidAmount": 1790,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-04-04"
  },
  {
    "id": "OS-1118",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-03-28",
    "status": "Entregue",
    "totalAmount": 1058,
    "paidAmount": 623,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-04-06"
  },
  {
    "id": "OS-1119",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-03-28",
    "status": "Entregue",
    "totalAmount": 1448,
    "paidAmount": 1448,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-04-14"
  },
  {
    "id": "OS-1120",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-03-29",
    "status": "Entregue",
    "totalAmount": 1093,
    "paidAmount": 557,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-04-18"
  },
  {
    "id": "OS-1121",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-03-31",
    "status": "Entregue",
    "totalAmount": 1087,
    "paidAmount": 609,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-04-11"
  },
  {
    "id": "OS-1122",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-03-31",
    "status": "Entregue",
    "totalAmount": 1146,
    "paidAmount": 1146,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-04-13"
  },
  {
    "id": "OS-1123",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-04-01",
    "status": "Entregue",
    "totalAmount": 1165,
    "paidAmount": 1152,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-04-19"
  },
  {
    "id": "OS-1124",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-04-01",
    "status": "Entregue",
    "totalAmount": 1946,
    "paidAmount": 1307,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-04-12"
  },
  {
    "id": "OS-1125",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-04-02",
    "status": "Entregue",
    "totalAmount": 1207,
    "paidAmount": 1207,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-04-10"
  },
  {
    "id": "OS-1126",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-04-03",
    "status": "Entregue",
    "totalAmount": 2710,
    "paidAmount": 2710,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-04-16"
  },
  {
    "id": "OS-1127",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-04-03",
    "status": "Entregue",
    "totalAmount": 1227,
    "paidAmount": 1227,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-04-22"
  },
  {
    "id": "OS-1128",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-04-04",
    "status": "Entregue",
    "totalAmount": 1402,
    "paidAmount": 1402,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-04-24"
  },
  {
    "id": "OS-1129",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-04-04",
    "status": "Entregue",
    "totalAmount": 1382,
    "paidAmount": 1094,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-04-16"
  },
  {
    "id": "OS-1130",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-04-05",
    "status": "Entregue",
    "totalAmount": 2553,
    "paidAmount": 2553,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-04-25"
  },
  {
    "id": "OS-1131",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-04-07",
    "status": "Entregue",
    "totalAmount": 720,
    "paidAmount": 720,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-04-15"
  },
  {
    "id": "OS-1132",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-04-07",
    "status": "Entregue",
    "totalAmount": 2315,
    "paidAmount": 2315,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-04-27"
  },
  {
    "id": "OS-1133",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-04-08",
    "status": "Entregue",
    "totalAmount": 2457,
    "paidAmount": 1428,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-04-19"
  },
  {
    "id": "OS-1134",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-04-08",
    "status": "Entregue",
    "totalAmount": 2001,
    "paidAmount": 2001,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-04-23"
  },
  {
    "id": "OS-1135",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-04-09",
    "status": "Entregue",
    "totalAmount": 1946,
    "paidAmount": 1570,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-04-16"
  },
  {
    "id": "OS-1136",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-04-10",
    "status": "Entregue",
    "totalAmount": 1384,
    "paidAmount": 1384,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-04-25"
  },
  {
    "id": "OS-1137",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-04-10",
    "status": "Entregue",
    "totalAmount": 1221,
    "paidAmount": 1221,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-04-17"
  },
  {
    "id": "OS-1138",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-04-11",
    "status": "Entregue",
    "totalAmount": 2102,
    "paidAmount": 2102,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-04-29"
  },
  {
    "id": "OS-1139",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-04-11",
    "status": "Entregue",
    "totalAmount": 2700,
    "paidAmount": 940,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-04-29"
  },
  {
    "id": "OS-1140",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-04-12",
    "status": "Entregue",
    "totalAmount": 1575,
    "paidAmount": 1575,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-04-27"
  },
  {
    "id": "OS-1141",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-04-14",
    "status": "Entregue",
    "totalAmount": 1458,
    "paidAmount": 1061,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-05-02"
  },
  {
    "id": "OS-1142",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-04-14",
    "status": "Entregue",
    "totalAmount": 2181,
    "paidAmount": 2181,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-04-21"
  },
  {
    "id": "OS-1143",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-04-15",
    "status": "Entregue",
    "totalAmount": 2536,
    "paidAmount": 2536,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-04-25"
  },
  {
    "id": "OS-1144",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-04-15",
    "status": "Entregue",
    "totalAmount": 2366,
    "paidAmount": 2366,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-05-05"
  },
  {
    "id": "OS-1145",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-04-16",
    "status": "Entregue",
    "totalAmount": 1178,
    "paidAmount": 1178,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-04-25"
  },
  {
    "id": "OS-1146",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-04-17",
    "status": "Entregue",
    "totalAmount": 1626,
    "paidAmount": 1626,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-05-06"
  },
  {
    "id": "OS-1147",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-04-17",
    "status": "Entregue",
    "totalAmount": 2516,
    "paidAmount": 2516,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-04-27"
  },
  {
    "id": "OS-1148",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-04-18",
    "status": "Entregue",
    "totalAmount": 2660,
    "paidAmount": 2660,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-05-01"
  },
  {
    "id": "OS-1149",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-04-18",
    "status": "Entregue",
    "totalAmount": 2765,
    "paidAmount": 2765,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-05-02"
  },
  {
    "id": "OS-1150",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-04-19",
    "status": "Entregue",
    "totalAmount": 2739,
    "paidAmount": 842,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-05-01"
  },
  {
    "id": "OS-1151",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-04-21",
    "status": "Entregue",
    "totalAmount": 1964,
    "paidAmount": 1964,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-05-11"
  },
  {
    "id": "OS-1152",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-04-21",
    "status": "Entregue",
    "totalAmount": 2363,
    "paidAmount": 2363,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-05-05"
  },
  {
    "id": "OS-1153",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-04-22",
    "status": "Entregue",
    "totalAmount": 1134,
    "paidAmount": 1134,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-05-03"
  },
  {
    "id": "OS-1154",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-04-22",
    "status": "Entregue",
    "totalAmount": 1290,
    "paidAmount": 1290,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-05-10"
  },
  {
    "id": "OS-1155",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-04-23",
    "status": "Entregue",
    "totalAmount": 2446,
    "paidAmount": 2321,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-05-02"
  },
  {
    "id": "OS-1156",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-04-24",
    "status": "Entregue",
    "totalAmount": 2295,
    "paidAmount": 2295,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-05-07"
  },
  {
    "id": "OS-1157",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-04-24",
    "status": "Entregue",
    "totalAmount": 2305,
    "paidAmount": 737,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-05-02"
  },
  {
    "id": "OS-1158",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-04-25",
    "status": "Entregue",
    "totalAmount": 2701,
    "paidAmount": 2701,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-05-11"
  },
  {
    "id": "OS-1159",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-04-25",
    "status": "Entregue",
    "totalAmount": 871,
    "paidAmount": 412,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-05-10"
  },
  {
    "id": "OS-1160",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-04-26",
    "status": "Entregue",
    "totalAmount": 1996,
    "paidAmount": 1990,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-05-05"
  },
  {
    "id": "OS-1161",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-04-28",
    "status": "Entregue",
    "totalAmount": 2188,
    "paidAmount": 2188,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-05-07"
  },
  {
    "id": "OS-1162",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-04-28",
    "status": "Entregue",
    "totalAmount": 791,
    "paidAmount": 791,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-05-14"
  },
  {
    "id": "OS-1163",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-04-29",
    "status": "Entregue",
    "totalAmount": 1905,
    "paidAmount": 1905,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-05-17"
  },
  {
    "id": "OS-1164",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-04-29",
    "status": "Entregue",
    "totalAmount": 953,
    "paidAmount": 517,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-05-06"
  },
  {
    "id": "OS-1165",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-04-30",
    "status": "Entregue",
    "totalAmount": 2606,
    "paidAmount": 2094,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-05-14"
  },
  {
    "id": "OS-1166",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-05-01",
    "status": "Entregue",
    "totalAmount": 1711,
    "paidAmount": 660,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-05-19"
  },
  {
    "id": "OS-1167",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-05-01",
    "status": "Entregue",
    "totalAmount": 2582,
    "paidAmount": 2582,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-05-19"
  },
  {
    "id": "OS-1168",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-05-02",
    "status": "Entregue",
    "totalAmount": 2161,
    "paidAmount": 2161,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-05-10"
  },
  {
    "id": "OS-1169",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-05-02",
    "status": "Entregue",
    "totalAmount": 750,
    "paidAmount": 750,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-05-09"
  },
  {
    "id": "OS-1170",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-05-03",
    "status": "Entregue",
    "totalAmount": 704,
    "paidAmount": 704,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-05-15"
  },
  {
    "id": "OS-1171",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-05-05",
    "status": "Entregue",
    "totalAmount": 2137,
    "paidAmount": 2137,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-05-17"
  },
  {
    "id": "OS-1172",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-05-05",
    "status": "Entregue",
    "totalAmount": 479,
    "paidAmount": 479,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-05-25"
  },
  {
    "id": "OS-1173",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-05-06",
    "status": "Entregue",
    "totalAmount": 757,
    "paidAmount": 757,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-05-25"
  },
  {
    "id": "OS-1174",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-05-06",
    "status": "Entregue",
    "totalAmount": 642,
    "paidAmount": 642,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-05-22"
  },
  {
    "id": "OS-1175",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-05-07",
    "status": "Entregue",
    "totalAmount": 2696,
    "paidAmount": 2628,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-05-15"
  },
  {
    "id": "OS-1176",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-05-08",
    "status": "Entregue",
    "totalAmount": 2094,
    "paidAmount": 2094,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-05-20"
  },
  {
    "id": "OS-1177",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-05-08",
    "status": "Entregue",
    "totalAmount": 2439,
    "paidAmount": 2439,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-05-23"
  },
  {
    "id": "OS-1178",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-05-09",
    "status": "Entregue",
    "totalAmount": 705,
    "paidAmount": 705,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-05-28"
  },
  {
    "id": "OS-1179",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-05-09",
    "status": "Entregue",
    "totalAmount": 1972,
    "paidAmount": 1972,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-05-19"
  },
  {
    "id": "OS-1180",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-05-10",
    "status": "Entregue",
    "totalAmount": 2386,
    "paidAmount": 2386,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-05-27"
  },
  {
    "id": "OS-1181",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-05-12",
    "status": "Entregue",
    "totalAmount": 1997,
    "paidAmount": 705,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-05-22"
  },
  {
    "id": "OS-1182",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-05-12",
    "status": "Entregue",
    "totalAmount": 1941,
    "paidAmount": 1941,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-05-28"
  },
  {
    "id": "OS-1183",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-05-13",
    "status": "Entregue",
    "totalAmount": 2645,
    "paidAmount": 2645,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-05-26"
  },
  {
    "id": "OS-1184",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-05-13",
    "status": "Entregue",
    "totalAmount": 1200,
    "paidAmount": 1200,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-05-20"
  },
  {
    "id": "OS-1185",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-05-14",
    "status": "Entregue",
    "totalAmount": 1819,
    "paidAmount": 1756,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-05-27"
  },
  {
    "id": "OS-1186",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-05-15",
    "status": "Entregue",
    "totalAmount": 2421,
    "paidAmount": 1245,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-06-01"
  },
  {
    "id": "OS-1187",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-05-15",
    "status": "Entregue",
    "totalAmount": 1579,
    "paidAmount": 901,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-05-30"
  },
  {
    "id": "OS-1188",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-05-16",
    "status": "Entregue",
    "totalAmount": 2338,
    "paidAmount": 1285,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-05-26"
  },
  {
    "id": "OS-1189",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-05-16",
    "status": "Entregue",
    "totalAmount": 2597,
    "paidAmount": 2597,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-06-03"
  },
  {
    "id": "OS-1190",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-05-17",
    "status": "Entregue",
    "totalAmount": 1647,
    "paidAmount": 1642,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-06-06"
  },
  {
    "id": "OS-1191",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-05-19",
    "status": "Entregue",
    "totalAmount": 2213,
    "paidAmount": 2213,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-06-02"
  },
  {
    "id": "OS-1192",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-05-19",
    "status": "Entregue",
    "totalAmount": 1077,
    "paidAmount": 1077,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-05-27"
  },
  {
    "id": "OS-1193",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-05-20",
    "status": "Entregue",
    "totalAmount": 2790,
    "paidAmount": 2790,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-05-29"
  },
  {
    "id": "OS-1194",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-05-20",
    "status": "Entregue",
    "totalAmount": 805,
    "paidAmount": 805,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-06-07"
  },
  {
    "id": "OS-1195",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-05-21",
    "status": "Entregue",
    "totalAmount": 957,
    "paidAmount": 957,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-05-28"
  },
  {
    "id": "OS-1196",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-05-22",
    "status": "Entregue",
    "totalAmount": 1673,
    "paidAmount": 1673,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-06-02"
  },
  {
    "id": "OS-1197",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-05-22",
    "status": "Entregue",
    "totalAmount": 750,
    "paidAmount": 750,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-05-30"
  },
  {
    "id": "OS-1198",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-05-23",
    "status": "Entregue",
    "totalAmount": 2220,
    "paidAmount": 2220,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-06-13"
  },
  {
    "id": "OS-1199",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-05-23",
    "status": "Entregue",
    "totalAmount": 2293,
    "paidAmount": 893,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-05-30"
  },
  {
    "id": "OS-1200",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-05-24",
    "status": "Entregue",
    "totalAmount": 2376,
    "paidAmount": 2376,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-06-12"
  },
  {
    "id": "OS-1201",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-05-26",
    "status": "Entregue",
    "totalAmount": 1356,
    "paidAmount": 1356,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-06-15"
  },
  {
    "id": "OS-1202",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-05-26",
    "status": "Entregue",
    "totalAmount": 544,
    "paidAmount": 529,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-06-08"
  },
  {
    "id": "OS-1203",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-05-27",
    "status": "Entregue",
    "totalAmount": 597,
    "paidAmount": 597,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-06-12"
  },
  {
    "id": "OS-1204",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-05-27",
    "status": "Entregue",
    "totalAmount": 462,
    "paidAmount": 462,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-06-08"
  },
  {
    "id": "OS-1205",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-05-28",
    "status": "Entregue",
    "totalAmount": 2042,
    "paidAmount": 2026,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-06-14"
  },
  {
    "id": "OS-1206",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-05-29",
    "status": "Entregue",
    "totalAmount": 2603,
    "paidAmount": 2603,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-06-16"
  },
  {
    "id": "OS-1207",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-05-29",
    "status": "Entregue",
    "totalAmount": 2221,
    "paidAmount": 2221,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-06-17"
  },
  {
    "id": "OS-1208",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-05-30",
    "status": "Entregue",
    "totalAmount": 2112,
    "paidAmount": 2112,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-06-07"
  },
  {
    "id": "OS-1209",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-05-30",
    "status": "Entregue",
    "totalAmount": 2349,
    "paidAmount": 2349,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-06-10"
  },
  {
    "id": "OS-1210",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-05-31",
    "status": "Entregue",
    "totalAmount": 1986,
    "paidAmount": 1986,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-06-20"
  },
  {
    "id": "OS-1211",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-06-02",
    "status": "Entregue",
    "totalAmount": 2476,
    "paidAmount": 2432,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-06-16"
  },
  {
    "id": "OS-1212",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-06-02",
    "status": "Entregue",
    "totalAmount": 1872,
    "paidAmount": 1872,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-06-16"
  },
  {
    "id": "OS-1213",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-06-03",
    "status": "Entregue",
    "totalAmount": 2427,
    "paidAmount": 2327,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-06-10"
  },
  {
    "id": "OS-1214",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-06-03",
    "status": "Entregue",
    "totalAmount": 1024,
    "paidAmount": 1024,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-06-22"
  },
  {
    "id": "OS-1215",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-06-04",
    "status": "Entregue",
    "totalAmount": 1390,
    "paidAmount": 1390,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-06-18"
  },
  {
    "id": "OS-1216",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-06-05",
    "status": "Entregue",
    "totalAmount": 2169,
    "paidAmount": 2169,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-06-17"
  },
  {
    "id": "OS-1217",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-06-05",
    "status": "Entregue",
    "totalAmount": 1366,
    "paidAmount": 1366,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-06-15"
  },
  {
    "id": "OS-1218",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-06-06",
    "status": "Entregue",
    "totalAmount": 2395,
    "paidAmount": 2395,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-06-19"
  },
  {
    "id": "OS-1219",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-06-06",
    "status": "Entregue",
    "totalAmount": 2501,
    "paidAmount": 2501,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-06-15"
  },
  {
    "id": "OS-1220",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-06-07",
    "status": "Entregue",
    "totalAmount": 1189,
    "paidAmount": 1189,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-06-18"
  },
  {
    "id": "OS-1221",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-06-09",
    "status": "Entregue",
    "totalAmount": 2188,
    "paidAmount": 2188,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-06-16"
  },
  {
    "id": "OS-1222",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-06-09",
    "status": "Entregue",
    "totalAmount": 2017,
    "paidAmount": 2017,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-06-26"
  },
  {
    "id": "OS-1223",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-06-10",
    "status": "Entregue",
    "totalAmount": 2702,
    "paidAmount": 2702,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-07-01"
  },
  {
    "id": "OS-1224",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-06-10",
    "status": "Entregue",
    "totalAmount": 1481,
    "paidAmount": 1481,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-06-19"
  },
  {
    "id": "OS-1225",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-06-11",
    "status": "Entregue",
    "totalAmount": 1457,
    "paidAmount": 513,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-06-19"
  },
  {
    "id": "OS-1226",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-06-12",
    "status": "Entregue",
    "totalAmount": 1097,
    "paidAmount": 1097,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-07-02"
  },
  {
    "id": "OS-1227",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-06-12",
    "status": "Entregue",
    "totalAmount": 1388,
    "paidAmount": 1388,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-06-21"
  },
  {
    "id": "OS-1228",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-06-13",
    "status": "Entregue",
    "totalAmount": 773,
    "paidAmount": 603,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-07-02"
  },
  {
    "id": "OS-1229",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-06-13",
    "status": "Entregue",
    "totalAmount": 736,
    "paidAmount": 736,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-06-23"
  },
  {
    "id": "OS-1230",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-06-14",
    "status": "Entregue",
    "totalAmount": 2575,
    "paidAmount": 2575,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-06-21"
  },
  {
    "id": "OS-1231",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-06-16",
    "status": "Entregue",
    "totalAmount": 1963,
    "paidAmount": 1963,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-07-02"
  },
  {
    "id": "OS-1232",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-06-16",
    "status": "Entregue",
    "totalAmount": 551,
    "paidAmount": 551,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-07-05"
  },
  {
    "id": "OS-1233",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-06-17",
    "status": "Entregue",
    "totalAmount": 1169,
    "paidAmount": 1169,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-06-24"
  },
  {
    "id": "OS-1234",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-06-17",
    "status": "Entregue",
    "totalAmount": 2785,
    "paidAmount": 2785,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-06-28"
  },
  {
    "id": "OS-1235",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-06-18",
    "status": "Entregue",
    "totalAmount": 1612,
    "paidAmount": 1612,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-07-04"
  },
  {
    "id": "OS-1236",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-06-19",
    "status": "Entregue",
    "totalAmount": 1063,
    "paidAmount": 373,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-07-04"
  },
  {
    "id": "OS-1237",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-06-19",
    "status": "Entregue",
    "totalAmount": 773,
    "paidAmount": 329,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-07-03"
  },
  {
    "id": "OS-1238",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-06-20",
    "status": "Entregue",
    "totalAmount": 911,
    "paidAmount": 911,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-07-09"
  },
  {
    "id": "OS-1239",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-06-20",
    "status": "Entregue",
    "totalAmount": 1435,
    "paidAmount": 1081,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-07-02"
  },
  {
    "id": "OS-1240",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-06-21",
    "status": "Entregue",
    "totalAmount": 2319,
    "paidAmount": 2319,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-06-28"
  },
  {
    "id": "OS-1241",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-06-23",
    "status": "Entregue",
    "totalAmount": 1392,
    "paidAmount": 1392,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-07-03"
  },
  {
    "id": "OS-1242",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-06-23",
    "status": "Entregue",
    "totalAmount": 1709,
    "paidAmount": 1709,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-07-07"
  },
  {
    "id": "OS-1243",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-06-24",
    "status": "Entregue",
    "totalAmount": 1987,
    "paidAmount": 1987,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-07-13"
  },
  {
    "id": "OS-1244",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-06-24",
    "status": "Entregue",
    "totalAmount": 757,
    "paidAmount": 757,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-07-11"
  },
  {
    "id": "OS-1245",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-06-25",
    "status": "Entregue",
    "totalAmount": 2212,
    "paidAmount": 909,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-07-12"
  },
  {
    "id": "OS-1246",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-06-26",
    "status": "Entregue",
    "totalAmount": 549,
    "paidAmount": 549,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-07-12"
  },
  {
    "id": "OS-1247",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-06-26",
    "status": "Entregue",
    "totalAmount": 465,
    "paidAmount": 262,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-07-06"
  },
  {
    "id": "OS-1248",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-06-27",
    "status": "Entregue",
    "totalAmount": 530,
    "paidAmount": 530,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-07-04"
  },
  {
    "id": "OS-1249",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-06-27",
    "status": "Entregue",
    "totalAmount": 2759,
    "paidAmount": 2640,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-07-16"
  },
  {
    "id": "OS-1250",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-06-28",
    "status": "Entregue",
    "totalAmount": 2585,
    "paidAmount": 2585,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-07-10"
  },
  {
    "id": "OS-1251",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-06-30",
    "status": "Entregue",
    "totalAmount": 2211,
    "paidAmount": 2211,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-07-18"
  },
  {
    "id": "OS-1252",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-06-30",
    "status": "Entregue",
    "totalAmount": 1843,
    "paidAmount": 1843,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-07-07"
  },
  {
    "id": "OS-1253",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-07-01",
    "status": "Entregue",
    "totalAmount": 917,
    "paidAmount": 917,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-07-18"
  },
  {
    "id": "OS-1254",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-07-01",
    "status": "Entregue",
    "totalAmount": 2787,
    "paidAmount": 2787,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-07-09"
  },
  {
    "id": "OS-1255",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-07-02",
    "status": "Entregue",
    "totalAmount": 1741,
    "paidAmount": 802,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-07-18"
  },
  {
    "id": "OS-1256",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-07-03",
    "status": "Entregue",
    "totalAmount": 2286,
    "paidAmount": 2286,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-07-20"
  },
  {
    "id": "OS-1257",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-07-03",
    "status": "Entregue",
    "totalAmount": 2341,
    "paidAmount": 2341,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-07-23"
  },
  {
    "id": "OS-1258",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-07-04",
    "status": "Entregue",
    "totalAmount": 1888,
    "paidAmount": 1363,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-07-16"
  },
  {
    "id": "OS-1259",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-07-04",
    "status": "Entregue",
    "totalAmount": 2712,
    "paidAmount": 2472,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-07-11"
  },
  {
    "id": "OS-1260",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-07-05",
    "status": "Entregue",
    "totalAmount": 1020,
    "paidAmount": 1020,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-07-20"
  },
  {
    "id": "OS-1261",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-07-07",
    "status": "Entregue",
    "totalAmount": 1690,
    "paidAmount": 1604,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-07-28"
  },
  {
    "id": "OS-1262",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-07-07",
    "status": "Entregue",
    "totalAmount": 2150,
    "paidAmount": 2044,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-07-25"
  },
  {
    "id": "OS-1263",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-07-08",
    "status": "Entregue",
    "totalAmount": 1367,
    "paidAmount": 438,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-07-27"
  },
  {
    "id": "OS-1264",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-07-08",
    "status": "Entregue",
    "totalAmount": 1101,
    "paidAmount": 1101,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-07-28"
  },
  {
    "id": "OS-1265",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-07-09",
    "status": "Entregue",
    "totalAmount": 944,
    "paidAmount": 944,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-07-20"
  },
  {
    "id": "OS-1266",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-07-10",
    "status": "Entregue",
    "totalAmount": 575,
    "paidAmount": 575,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-07-22"
  },
  {
    "id": "OS-1267",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-07-10",
    "status": "Entregue",
    "totalAmount": 2696,
    "paidAmount": 917,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-07-24"
  },
  {
    "id": "OS-1268",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-07-11",
    "status": "Entregue",
    "totalAmount": 803,
    "paidAmount": 803,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-07-23"
  },
  {
    "id": "OS-1269",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-07-11",
    "status": "Entregue",
    "totalAmount": 1626,
    "paidAmount": 748,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-07-18"
  },
  {
    "id": "OS-1270",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-07-12",
    "status": "Entregue",
    "totalAmount": 1466,
    "paidAmount": 1466,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-07-22"
  },
  {
    "id": "OS-1271",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-07-14",
    "status": "Entregue",
    "totalAmount": 1583,
    "paidAmount": 1583,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-08-04"
  },
  {
    "id": "OS-1272",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-07-14",
    "status": "Entregue",
    "totalAmount": 2495,
    "paidAmount": 2495,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-08-02"
  },
  {
    "id": "OS-1273",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-07-15",
    "status": "Entregue",
    "totalAmount": 914,
    "paidAmount": 914,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-07-31"
  },
  {
    "id": "OS-1274",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-07-15",
    "status": "Entregue",
    "totalAmount": 779,
    "paidAmount": 779,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-07-31"
  },
  {
    "id": "OS-1275",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-07-16",
    "status": "Entregue",
    "totalAmount": 2251,
    "paidAmount": 718,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-07-29"
  },
  {
    "id": "OS-1276",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-07-17",
    "status": "Entregue",
    "totalAmount": 2787,
    "paidAmount": 2787,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-08-02"
  },
  {
    "id": "OS-1277",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-07-17",
    "status": "Entregue",
    "totalAmount": 1860,
    "paidAmount": 1179,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-08-04"
  },
  {
    "id": "OS-1278",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-07-18",
    "status": "Entregue",
    "totalAmount": 2270,
    "paidAmount": 1855,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-08-03"
  },
  {
    "id": "OS-1279",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-07-18",
    "status": "Entregue",
    "totalAmount": 1519,
    "paidAmount": 1341,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-07-27"
  },
  {
    "id": "OS-1280",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-07-19",
    "status": "Entregue",
    "totalAmount": 1560,
    "paidAmount": 1560,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-08-02"
  },
  {
    "id": "OS-1281",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-07-21",
    "status": "Entregue",
    "totalAmount": 813,
    "paidAmount": 813,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-08-10"
  },
  {
    "id": "OS-1282",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-07-21",
    "status": "Entregue",
    "totalAmount": 1608,
    "paidAmount": 832,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-07-28"
  },
  {
    "id": "OS-1283",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-07-22",
    "status": "Entregue",
    "totalAmount": 1425,
    "paidAmount": 1425,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-08-08"
  },
  {
    "id": "OS-1284",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-07-22",
    "status": "Entregue",
    "totalAmount": 1227,
    "paidAmount": 1227,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-07-30"
  },
  {
    "id": "OS-1285",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-07-23",
    "status": "Entregue",
    "totalAmount": 1751,
    "paidAmount": 1751,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-07-31"
  },
  {
    "id": "OS-1286",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-07-24",
    "status": "Entregue",
    "totalAmount": 809,
    "paidAmount": 619,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-08-10"
  },
  {
    "id": "OS-1287",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-07-24",
    "status": "Entregue",
    "totalAmount": 1289,
    "paidAmount": 1289,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-08-08"
  },
  {
    "id": "OS-1288",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-07-25",
    "status": "Entregue",
    "totalAmount": 1184,
    "paidAmount": 883,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-08-12"
  },
  {
    "id": "OS-1289",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-07-25",
    "status": "Entregue",
    "totalAmount": 2024,
    "paidAmount": 1056,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-08-01"
  },
  {
    "id": "OS-1290",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-07-26",
    "status": "Entregue",
    "totalAmount": 2440,
    "paidAmount": 2440,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-08-10"
  },
  {
    "id": "OS-1291",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-07-28",
    "status": "Entregue",
    "totalAmount": 1640,
    "paidAmount": 1073,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-08-10"
  },
  {
    "id": "OS-1292",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-07-28",
    "status": "Entregue",
    "totalAmount": 1024,
    "paidAmount": 353,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-08-14"
  },
  {
    "id": "OS-1293",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-07-29",
    "status": "Entregue",
    "totalAmount": 2081,
    "paidAmount": 2081,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-08-12"
  },
  {
    "id": "OS-1294",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-07-29",
    "status": "Entregue",
    "totalAmount": 1439,
    "paidAmount": 1439,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-08-10"
  },
  {
    "id": "OS-1295",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-07-30",
    "status": "Entregue",
    "totalAmount": 1517,
    "paidAmount": 1517,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-08-08"
  },
  {
    "id": "OS-1296",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-07-31",
    "status": "Entregue",
    "totalAmount": 876,
    "paidAmount": 622,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-08-21"
  },
  {
    "id": "OS-1297",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-07-31",
    "status": "Entregue",
    "totalAmount": 2711,
    "paidAmount": 2529,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-08-14"
  },
  {
    "id": "OS-1298",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-08-01",
    "status": "Entregue",
    "totalAmount": 2746,
    "paidAmount": 2746,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-08-18"
  },
  {
    "id": "OS-1299",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-08-01",
    "status": "Entregue",
    "totalAmount": 1928,
    "paidAmount": 1928,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-08-17"
  },
  {
    "id": "OS-1300",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-08-02",
    "status": "Entregue",
    "totalAmount": 1714,
    "paidAmount": 1714,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-08-21"
  },
  {
    "id": "OS-1301",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-08-04",
    "status": "Entregue",
    "totalAmount": 484,
    "paidAmount": 478,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-08-24"
  },
  {
    "id": "OS-1302",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-08-04",
    "status": "Entregue",
    "totalAmount": 1976,
    "paidAmount": 691,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-08-12"
  },
  {
    "id": "OS-1303",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-08-05",
    "status": "Entregue",
    "totalAmount": 1653,
    "paidAmount": 611,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-08-15"
  },
  {
    "id": "OS-1304",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-08-05",
    "status": "Entregue",
    "totalAmount": 1333,
    "paidAmount": 1333,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-08-13"
  },
  {
    "id": "OS-1305",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-08-06",
    "status": "Entregue",
    "totalAmount": 2006,
    "paidAmount": 2006,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-08-14"
  },
  {
    "id": "OS-1306",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-08-07",
    "status": "Entregue",
    "totalAmount": 2348,
    "paidAmount": 1246,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-08-16"
  },
  {
    "id": "OS-1307",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-08-07",
    "status": "Entregue",
    "totalAmount": 1177,
    "paidAmount": 1177,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-08-17"
  },
  {
    "id": "OS-1308",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-08-08",
    "status": "Entregue",
    "totalAmount": 1386,
    "paidAmount": 1386,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-08-19"
  },
  {
    "id": "OS-1309",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-08-08",
    "status": "Entregue",
    "totalAmount": 2548,
    "paidAmount": 2548,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-08-22"
  },
  {
    "id": "OS-1310",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-08-09",
    "status": "Entregue",
    "totalAmount": 461,
    "paidAmount": 226,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-08-17"
  },
  {
    "id": "OS-1311",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-08-11",
    "status": "Entregue",
    "totalAmount": 719,
    "paidAmount": 305,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-08-20"
  },
  {
    "id": "OS-1312",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-08-11",
    "status": "Entregue",
    "totalAmount": 771,
    "paidAmount": 771,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-08-19"
  },
  {
    "id": "OS-1313",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-08-12",
    "status": "Entregue",
    "totalAmount": 820,
    "paidAmount": 820,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-08-19"
  },
  {
    "id": "OS-1314",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-08-12",
    "status": "Entregue",
    "totalAmount": 2586,
    "paidAmount": 1385,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-08-30"
  },
  {
    "id": "OS-1315",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-08-13",
    "status": "Entregue",
    "totalAmount": 1568,
    "paidAmount": 1568,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-08-20"
  },
  {
    "id": "OS-1316",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-08-14",
    "status": "Entregue",
    "totalAmount": 2399,
    "paidAmount": 2399,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-09-03"
  },
  {
    "id": "OS-1317",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-08-14",
    "status": "Entregue",
    "totalAmount": 2307,
    "paidAmount": 2110,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-08-31"
  },
  {
    "id": "OS-1318",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-08-15",
    "status": "Entregue",
    "totalAmount": 2158,
    "paidAmount": 1380,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-08-25"
  },
  {
    "id": "OS-1319",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-08-15",
    "status": "Entregue",
    "totalAmount": 867,
    "paidAmount": 445,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-09-02"
  },
  {
    "id": "OS-1320",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-08-16",
    "status": "Entregue",
    "totalAmount": 2497,
    "paidAmount": 1192,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-09-03"
  },
  {
    "id": "OS-1321",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-08-18",
    "status": "Entregue",
    "totalAmount": 1023,
    "paidAmount": 1023,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-09-07"
  },
  {
    "id": "OS-1322",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-08-18",
    "status": "Entregue",
    "totalAmount": 2405,
    "paidAmount": 2405,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-09-05"
  },
  {
    "id": "OS-1323",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-08-19",
    "status": "Entregue",
    "totalAmount": 899,
    "paidAmount": 410,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-08-29"
  },
  {
    "id": "OS-1324",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-08-19",
    "status": "Entregue",
    "totalAmount": 720,
    "paidAmount": 412,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-08-29"
  },
  {
    "id": "OS-1325",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-08-20",
    "status": "Entregue",
    "totalAmount": 2107,
    "paidAmount": 1821,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-09-08"
  },
  {
    "id": "OS-1326",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-08-21",
    "status": "Entregue",
    "totalAmount": 922,
    "paidAmount": 922,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-09-03"
  },
  {
    "id": "OS-1327",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-08-21",
    "status": "Entregue",
    "totalAmount": 2777,
    "paidAmount": 930,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-09-09"
  },
  {
    "id": "OS-1328",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-08-22",
    "status": "Entregue",
    "totalAmount": 919,
    "paidAmount": 919,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-09-08"
  },
  {
    "id": "OS-1329",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-08-22",
    "status": "Entregue",
    "totalAmount": 566,
    "paidAmount": 566,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-09-01"
  },
  {
    "id": "OS-1330",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-08-23",
    "status": "Entregue",
    "totalAmount": 1333,
    "paidAmount": 1333,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-09-07"
  },
  {
    "id": "OS-1331",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-08-25",
    "status": "Entregue",
    "totalAmount": 788,
    "paidAmount": 252,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-09-06"
  },
  {
    "id": "OS-1332",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-08-25",
    "status": "Entregue",
    "totalAmount": 466,
    "paidAmount": 466,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-09-03"
  },
  {
    "id": "OS-1333",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-08-26",
    "status": "Entregue",
    "totalAmount": 707,
    "paidAmount": 707,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-09-04"
  },
  {
    "id": "OS-1334",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-08-26",
    "status": "Entregue",
    "totalAmount": 1413,
    "paidAmount": 908,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-09-02"
  },
  {
    "id": "OS-1335",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-08-27",
    "status": "Entregue",
    "totalAmount": 2045,
    "paidAmount": 1952,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-09-14"
  },
  {
    "id": "OS-1336",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-08-28",
    "status": "Entregue",
    "totalAmount": 849,
    "paidAmount": 849,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-09-09"
  },
  {
    "id": "OS-1337",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-08-28",
    "status": "Entregue",
    "totalAmount": 936,
    "paidAmount": 936,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-09-07"
  },
  {
    "id": "OS-1338",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-08-29",
    "status": "Entregue",
    "totalAmount": 588,
    "paidAmount": 588,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-09-14"
  },
  {
    "id": "OS-1339",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-08-29",
    "status": "Entregue",
    "totalAmount": 2433,
    "paidAmount": 2433,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-09-15"
  },
  {
    "id": "OS-1340",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-08-30",
    "status": "Entregue",
    "totalAmount": 2279,
    "paidAmount": 2279,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-09-18"
  },
  {
    "id": "OS-1341",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-09-01",
    "status": "Entregue",
    "totalAmount": 644,
    "paidAmount": 639,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-09-18"
  },
  {
    "id": "OS-1342",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-09-01",
    "status": "Entregue",
    "totalAmount": 2579,
    "paidAmount": 2579,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-09-11"
  },
  {
    "id": "OS-1343",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-09-02",
    "status": "Entregue",
    "totalAmount": 1467,
    "paidAmount": 1467,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-09-18"
  },
  {
    "id": "OS-1344",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-09-02",
    "status": "Entregue",
    "totalAmount": 1500,
    "paidAmount": 1500,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-09-16"
  },
  {
    "id": "OS-1345",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-09-03",
    "status": "Entregue",
    "totalAmount": 1515,
    "paidAmount": 1515,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-09-21"
  },
  {
    "id": "OS-1346",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-09-04",
    "status": "Entregue",
    "totalAmount": 1229,
    "paidAmount": 1229,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-09-12"
  },
  {
    "id": "OS-1347",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-09-04",
    "status": "Entregue",
    "totalAmount": 1210,
    "paidAmount": 1210,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-09-13"
  },
  {
    "id": "OS-1348",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-09-05",
    "status": "Entregue",
    "totalAmount": 1880,
    "paidAmount": 1315,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-09-22"
  },
  {
    "id": "OS-1349",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-09-05",
    "status": "Entregue",
    "totalAmount": 2587,
    "paidAmount": 2587,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-09-22"
  },
  {
    "id": "OS-1350",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-09-06",
    "status": "Entregue",
    "totalAmount": 496,
    "paidAmount": 496,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-09-13"
  },
  {
    "id": "OS-1351",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-09-08",
    "status": "Entregue",
    "totalAmount": 842,
    "paidAmount": 842,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-09-21"
  },
  {
    "id": "OS-1352",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-09-08",
    "status": "Entregue",
    "totalAmount": 1135,
    "paidAmount": 495,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-09-28"
  },
  {
    "id": "OS-1353",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-09-09",
    "status": "Entregue",
    "totalAmount": 2377,
    "paidAmount": 2377,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-09-18"
  },
  {
    "id": "OS-1354",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-09-09",
    "status": "Entregue",
    "totalAmount": 1279,
    "paidAmount": 1279,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-09-19"
  },
  {
    "id": "OS-1355",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-09-10",
    "status": "Entregue",
    "totalAmount": 2550,
    "paidAmount": 1929,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-09-28"
  },
  {
    "id": "OS-1356",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-09-11",
    "status": "Entregue",
    "totalAmount": 1397,
    "paidAmount": 1397,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-09-21"
  },
  {
    "id": "OS-1357",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-09-11",
    "status": "Entregue",
    "totalAmount": 1502,
    "paidAmount": 514,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-09-21"
  },
  {
    "id": "OS-1358",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-09-12",
    "status": "Entregue",
    "totalAmount": 1630,
    "paidAmount": 1630,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-09-30"
  },
  {
    "id": "OS-1359",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-09-12",
    "status": "Entregue",
    "totalAmount": 2108,
    "paidAmount": 738,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-09-19"
  },
  {
    "id": "OS-1360",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-09-13",
    "status": "Entregue",
    "totalAmount": 1701,
    "paidAmount": 1701,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-10-02"
  },
  {
    "id": "OS-1361",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-09-15",
    "status": "Entregue",
    "totalAmount": 1687,
    "paidAmount": 1687,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-10-06"
  },
  {
    "id": "OS-1362",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-09-15",
    "status": "Entregue",
    "totalAmount": 2179,
    "paidAmount": 2179,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-09-24"
  },
  {
    "id": "OS-1363",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-09-16",
    "status": "Entregue",
    "totalAmount": 2449,
    "paidAmount": 2449,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-10-05"
  },
  {
    "id": "OS-1364",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-09-16",
    "status": "Entregue",
    "totalAmount": 1493,
    "paidAmount": 1493,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-09-26"
  },
  {
    "id": "OS-1365",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-09-17",
    "status": "Entregue",
    "totalAmount": 1579,
    "paidAmount": 1579,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-10-01"
  },
  {
    "id": "OS-1366",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-09-18",
    "status": "Entregue",
    "totalAmount": 1737,
    "paidAmount": 1686,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-09-27"
  },
  {
    "id": "OS-1367",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-09-18",
    "status": "Entregue",
    "totalAmount": 1985,
    "paidAmount": 1985,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-10-05"
  },
  {
    "id": "OS-1368",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-09-19",
    "status": "Entregue",
    "totalAmount": 747,
    "paidAmount": 305,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-10-03"
  },
  {
    "id": "OS-1369",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-09-19",
    "status": "Entregue",
    "totalAmount": 462,
    "paidAmount": 458,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-09-26"
  },
  {
    "id": "OS-1370",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-09-20",
    "status": "Entregue",
    "totalAmount": 1491,
    "paidAmount": 1491,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-09-30"
  },
  {
    "id": "OS-1371",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-09-22",
    "status": "Entregue",
    "totalAmount": 692,
    "paidAmount": 692,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-10-08"
  },
  {
    "id": "OS-1372",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-09-22",
    "status": "Entregue",
    "totalAmount": 1213,
    "paidAmount": 1213,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-10-01"
  },
  {
    "id": "OS-1373",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-09-23",
    "status": "Entregue",
    "totalAmount": 1403,
    "paidAmount": 1403,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-09-30"
  },
  {
    "id": "OS-1374",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-09-23",
    "status": "Entregue",
    "totalAmount": 1925,
    "paidAmount": 1873,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-10-09"
  },
  {
    "id": "OS-1375",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-09-24",
    "status": "Entregue",
    "totalAmount": 2654,
    "paidAmount": 2654,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Prada Geometric Metal",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-10-02"
  },
  {
    "id": "OS-1376",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-09-25",
    "status": "Entregue",
    "totalAmount": 1127,
    "paidAmount": 1127,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-10-03"
  },
  {
    "id": "OS-1377",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-09-25",
    "status": "Entregue",
    "totalAmount": 1587,
    "paidAmount": 1587,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-10-07"
  },
  {
    "id": "OS-1378",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-09-26",
    "status": "Entregue",
    "totalAmount": 1140,
    "paidAmount": 1140,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-10-12"
  },
  {
    "id": "OS-1379",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-09-26",
    "status": "Entregue",
    "totalAmount": 1295,
    "paidAmount": 911,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-10-08"
  },
  {
    "id": "OS-1380",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-09-27",
    "status": "Entregue",
    "totalAmount": 1425,
    "paidAmount": 1425,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-10-18"
  },
  {
    "id": "OS-1381",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-09-29",
    "status": "Entregue",
    "totalAmount": 1916,
    "paidAmount": 1916,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-10-18"
  },
  {
    "id": "OS-1382",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-09-29",
    "status": "Entregue",
    "totalAmount": 1463,
    "paidAmount": 1338,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-10-15"
  },
  {
    "id": "OS-1383",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-09-30",
    "status": "Entregue",
    "totalAmount": 2292,
    "paidAmount": 1038,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-10-16"
  },
  {
    "id": "OS-1384",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-09-30",
    "status": "Entregue",
    "totalAmount": 1336,
    "paidAmount": 1336,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-10-10"
  },
  {
    "id": "OS-1385",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-10-01",
    "status": "Entregue",
    "totalAmount": 735,
    "paidAmount": 457,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-10-21"
  },
  {
    "id": "OS-1386",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-10-02",
    "status": "Entregue",
    "totalAmount": 1991,
    "paidAmount": 1991,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-10-11"
  },
  {
    "id": "OS-1387",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-10-02",
    "status": "Entregue",
    "totalAmount": 2406,
    "paidAmount": 2406,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-10-20"
  },
  {
    "id": "OS-1388",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-10-03",
    "status": "Já está na Loja",
    "totalAmount": 2159,
    "paidAmount": 2159,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Giorgio Armani Slim Dourado",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-10-17"
  },
  {
    "id": "OS-1389",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-10-03",
    "status": "Já está na Loja",
    "totalAmount": 2614,
    "paidAmount": 2614,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-10-11"
  },
  {
    "id": "OS-1390",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-10-04",
    "status": "Já está na Loja",
    "totalAmount": 2384,
    "paidAmount": 2384,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-10-22"
  },
  {
    "id": "OS-1391",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-10-06",
    "status": "Já está na Loja",
    "totalAmount": 1938,
    "paidAmount": 625,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-10-17"
  },
  {
    "id": "OS-1392",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-10-06",
    "status": "Já está na Loja",
    "totalAmount": 966,
    "paidAmount": 737,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-10-15"
  },
  {
    "id": "OS-1393",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-10-07",
    "status": "Já está na Loja",
    "totalAmount": 1024,
    "paidAmount": 1024,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-10-18"
  },
  {
    "id": "OS-1394",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-10-07",
    "status": "Já está na Loja",
    "totalAmount": 980,
    "paidAmount": 980,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-10-21"
  },
  {
    "id": "OS-1395",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-10-08",
    "status": "Já está na Loja",
    "totalAmount": 2126,
    "paidAmount": 2126,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-10-24"
  },
  {
    "id": "OS-1396",
    "customerId": "demo-cust-5",
    "customerName": "Juliana Ferreira Costa",
    "date": "2026-10-09",
    "status": "Já está na Loja",
    "totalAmount": 1394,
    "paidAmount": 1221,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Solar Polarizada Marrom",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-10-27"
  },
  {
    "id": "OS-1397",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-10-09",
    "status": "Já está na Loja",
    "totalAmount": 816,
    "paidAmount": 645,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-10-24"
  },
  {
    "id": "OS-1398",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-10-10",
    "status": "Já está na Loja",
    "totalAmount": 1413,
    "paidAmount": 1413,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-10-24"
  },
  {
    "id": "OS-1399",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-10-10",
    "status": "Já está na Loja",
    "totalAmount": 828,
    "paidAmount": 828,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Solar Polarizada Cinza",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-10-17"
  },
  {
    "id": "OS-1400",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-10-11",
    "status": "Já está na Loja",
    "totalAmount": 1315,
    "paidAmount": 1315,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Oakley Holbrook Fosco",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-10-20"
  },
  {
    "id": "OS-1401",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-10-13",
    "status": "Já está na Loja",
    "totalAmount": 1009,
    "paidAmount": 1009,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Multifocal 1.74 Super Fino",
    "lensNotes": "",
    "lab": "Essilor Lab Express",
    "deliveryDate": "2026-10-26"
  },
  {
    "id": "OS-1402",
    "customerId": "demo-cust-1",
    "customerName": "Ana Clara Albuquerque",
    "date": "2026-10-13",
    "status": "Já está na Loja",
    "totalAmount": 2197,
    "paidAmount": 2197,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-10-28"
  },
  {
    "id": "OS-1403",
    "customerId": "demo-cust-9",
    "customerName": "Camila Torres Rodrigues",
    "date": "2026-10-14",
    "status": "Enviado p/ Lab",
    "totalAmount": 1578,
    "paidAmount": 1578,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Clubmaster Tartaruga",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-10-31"
  },
  {
    "id": "OS-1404",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-10-14",
    "status": "Enviado p/ Lab",
    "totalAmount": 791,
    "paidAmount": 791,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-11-04"
  },
  {
    "id": "OS-1405",
    "customerId": "demo-cust-7",
    "customerName": "Patricia Alves Nunes",
    "date": "2026-10-15",
    "status": "Enviado p/ Lab",
    "totalAmount": 1400,
    "paidAmount": 1400,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-10-27"
  },
  {
    "id": "OS-1406",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-10-16",
    "status": "Enviado p/ Lab",
    "totalAmount": 903,
    "paidAmount": 901,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-10-31"
  },
  {
    "id": "OS-1407",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-10-16",
    "status": "Enviado p/ Lab",
    "totalAmount": 1810,
    "paidAmount": 1810,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-11-06"
  },
  {
    "id": "OS-1408",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-10-17",
    "status": "Enviado p/ Lab",
    "totalAmount": 660,
    "paidAmount": 660,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Chilli Beans Round Madeira",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-11-02"
  },
  {
    "id": "OS-1409",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-10-17",
    "status": "Enviado p/ Lab",
    "totalAmount": 2290,
    "paidAmount": 2290,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Monofocal Antirreflexo Premium",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-11-02"
  },
  {
    "id": "OS-1410",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-10-18",
    "status": "Enviado p/ Lab",
    "totalAmount": 2359,
    "paidAmount": 2359,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-10-25"
  },
  {
    "id": "OS-1411",
    "customerId": "demo-cust-8",
    "customerName": "Marcos Antonio Barbosa",
    "date": "2026-10-20",
    "status": "Enviado p/ Lab",
    "totalAmount": 2485,
    "paidAmount": 1457,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Michael Kors Aviador Dourado",
    "frameNotes": "",
    "lensType": "Monofocal 1.56 Básica",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-11-06"
  },
  {
    "id": "OS-1412",
    "customerId": "demo-cust-6",
    "customerName": "Roberto Souza Mendes",
    "date": "2026-10-20",
    "status": "Enviado p/ Lab",
    "totalAmount": 584,
    "paidAmount": 584,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-11-06"
  },
  {
    "id": "OS-1413",
    "customerId": "demo-cust-10",
    "customerName": "Diego Henrique Pereira",
    "date": "2026-10-21",
    "status": "Falta Enviar",
    "totalAmount": 1996,
    "paidAmount": 1996,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Dolce Gabbana Acetato Bordo",
    "frameNotes": "",
    "lensType": "Multifocal Premium Varilux",
    "lensNotes": "",
    "lab": "OptiLab Nacional",
    "deliveryDate": "2026-11-06"
  },
  {
    "id": "OS-1414",
    "customerId": "demo-cust-11",
    "customerName": "Larissa Monteiro Campos",
    "date": "2026-10-21",
    "status": "Falta Enviar",
    "totalAmount": 2231,
    "paidAmount": 2231,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Tommy Hilfiger Azul Marinho",
    "frameNotes": "",
    "lensType": "Multifocal Digital 1.67 BlueCut",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-10-28"
  },
  {
    "id": "OS-1415",
    "customerId": "demo-cust-4",
    "customerName": "Fernando Augusto Lima",
    "date": "2026-10-22",
    "status": "Falta Enviar",
    "totalAmount": 1259,
    "paidAmount": 1259,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Guess Metal Prata",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Laboratório Central Vision",
    "deliveryDate": "2026-11-10"
  },
  {
    "id": "OS-1416",
    "customerId": "demo-cust-2",
    "customerName": "Carlos Eduardo Oliveira",
    "date": "2026-10-23",
    "status": "Falta Enviar",
    "totalAmount": 453,
    "paidAmount": 453,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Monofocal Minerite 1.6",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-10-30"
  },
  {
    "id": "OS-1417",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-10-23",
    "status": "Falta Enviar",
    "totalAmount": 1334,
    "paidAmount": 1334,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Nike Esportivo Preto",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-11-08"
  },
  {
    "id": "OS-1418",
    "customerId": "demo-cust-12",
    "customerName": "Rafael Carvalho Gomes",
    "date": "2026-10-24",
    "status": "Falta Enviar",
    "totalAmount": 1205,
    "paidAmount": 1109,
    "paymentStatus": "Parcial",
    "prescriptionId": "",
    "frameModel": "Vogue Eyewear Metal Dourado",
    "frameNotes": "",
    "lensType": "Fotossensível Transitions Gen 8",
    "lensNotes": "",
    "lab": "Hoya Lab São Paulo",
    "deliveryDate": "2026-11-06"
  },
  {
    "id": "OS-1419",
    "customerId": "demo-cust-3",
    "customerName": "Beatriz Martins Santos",
    "date": "2026-10-24",
    "status": "Falta Enviar",
    "totalAmount": 773,
    "paidAmount": 773,
    "paymentStatus": "Pago",
    "prescriptionId": "",
    "frameModel": "Ray-Ban Wayfarer Acetato Preto",
    "frameNotes": "",
    "lensType": "Bifocal Cristal Básico",
    "lensNotes": "",
    "lab": "Zeiss Precision Lab",
    "deliveryDate": "2026-11-11"
  }
] as any[]).map((o: any) => ({
  ...o,
  status: o.status as OrderStatus,
  paymentStatus: o.paymentStatus as PaymentStatus,
}));

export const SEED_TRANSACTIONS: FinancialTransaction[] = [
  {
    "id": "tx-1",
    "date": "2026-01-06",
    "description": "Venda de Óculos - OS-1001 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 1951,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-2",
    "date": "2026-01-06",
    "description": "Venda de Óculos - OS-1002 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 2181,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-3",
    "date": "2026-01-07",
    "description": "Venda de Óculos - OS-1003 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 1509,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-4",
    "date": "2026-01-07",
    "description": "Venda de Óculos - OS-1004 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 1031,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-5",
    "date": "2026-01-08",
    "description": "Venda de Óculos - OS-1005 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 2138,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-6",
    "date": "2026-01-09",
    "description": "Venda de Óculos - OS-1006 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 494,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-7",
    "date": "2026-01-09",
    "description": "Venda de Óculos - OS-1007 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 1724,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-8",
    "date": "2026-01-10",
    "description": "Venda de Óculos - OS-1008 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 1256,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-9",
    "date": "2026-01-10",
    "description": "Venda de Óculos - OS-1009 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 1203,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-10",
    "date": "2026-01-11",
    "description": "Venda de Óculos - OS-1010 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 1675,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-11",
    "date": "2026-01-13",
    "description": "Venda de Óculos - OS-1011 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1954,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-12",
    "date": "2026-01-13",
    "description": "Venda de Óculos - OS-1012 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 610,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-13",
    "date": "2026-01-14",
    "description": "Venda de Óculos - OS-1013 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 1871,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-14",
    "date": "2026-01-14",
    "description": "Venda de Óculos - OS-1014 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 815,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-15",
    "date": "2026-01-15",
    "description": "Venda de Óculos - OS-1015 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 2119,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-16",
    "date": "2026-01-16",
    "description": "Venda de Óculos - OS-1016 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 564,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-17",
    "date": "2026-01-16",
    "description": "Venda de Óculos - OS-1017 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 1663,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-18",
    "date": "2026-01-17",
    "description": "Venda de Óculos - OS-1018 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 835,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-19",
    "date": "2026-01-17",
    "description": "Venda de Óculos - OS-1019 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 1578,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-20",
    "date": "2026-01-18",
    "description": "Venda de Óculos - OS-1020 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 293,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-21",
    "date": "2026-01-20",
    "description": "Venda de Óculos - OS-1021 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 2101,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-22",
    "date": "2026-01-20",
    "description": "Venda de Óculos - OS-1022 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1887,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-23",
    "date": "2026-01-21",
    "description": "Venda de Óculos - OS-1023 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1215,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-24",
    "date": "2026-01-21",
    "description": "Venda de Óculos - OS-1024 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 2154,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-25",
    "date": "2026-01-22",
    "description": "Venda de Óculos - OS-1025 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 2700,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-26",
    "date": "2026-01-23",
    "description": "Venda de Óculos - OS-1026 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 1883,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-27",
    "date": "2026-01-23",
    "description": "Venda de Óculos - OS-1027 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2276,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-28",
    "date": "2026-01-24",
    "description": "Venda de Óculos - OS-1028 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 630,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-29",
    "date": "2026-01-24",
    "description": "Venda de Óculos - OS-1029 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2634,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-30",
    "date": "2026-01-25",
    "description": "Venda de Óculos - OS-1030 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 1058,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-31",
    "date": "2026-01-27",
    "description": "Venda de Óculos - OS-1031 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 1926,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-32",
    "date": "2026-01-27",
    "description": "Venda de Óculos - OS-1032 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 2747,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-33",
    "date": "2026-01-28",
    "description": "Venda de Óculos - OS-1033 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 2224,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-34",
    "date": "2026-01-28",
    "description": "Venda de Óculos - OS-1034 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1416,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-35",
    "date": "2026-01-29",
    "description": "Venda de Óculos - OS-1035 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 2409,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-36",
    "date": "2026-01-30",
    "description": "Venda de Óculos - OS-1036 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 2165,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-37",
    "date": "2026-01-30",
    "description": "Venda de Óculos - OS-1037 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 1378,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-38",
    "date": "2026-01-31",
    "description": "Venda de Óculos - OS-1038 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 668,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-39",
    "date": "2026-01-31",
    "description": "Venda de Óculos - OS-1039 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 1451,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-40",
    "date": "2026-02-01",
    "description": "Venda de Óculos - OS-1040 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 2559,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-41",
    "date": "2026-02-03",
    "description": "Venda de Óculos - OS-1041 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 851,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-42",
    "date": "2026-02-03",
    "description": "Venda de Óculos - OS-1042 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 614,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-43",
    "date": "2026-02-04",
    "description": "Venda de Óculos - OS-1043 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 1918,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-44",
    "date": "2026-02-04",
    "description": "Venda de Óculos - OS-1044 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 963,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-45",
    "date": "2026-02-05",
    "description": "Venda de Óculos - OS-1045 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 2611,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-46",
    "date": "2026-02-06",
    "description": "Venda de Óculos - OS-1046 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 1881,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-47",
    "date": "2026-02-06",
    "description": "Venda de Óculos - OS-1047 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1958,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-48",
    "date": "2026-02-07",
    "description": "Venda de Óculos - OS-1048 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 519,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-49",
    "date": "2026-02-07",
    "description": "Venda de Óculos - OS-1049 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 2443,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-50",
    "date": "2026-02-08",
    "description": "Venda de Óculos - OS-1050 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 664,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-51",
    "date": "2026-02-10",
    "description": "Venda de Óculos - OS-1051 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1169,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-52",
    "date": "2026-02-10",
    "description": "Venda de Óculos - OS-1052 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 736,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-53",
    "date": "2026-02-11",
    "description": "Venda de Óculos - OS-1053 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 2502,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-54",
    "date": "2026-02-11",
    "description": "Venda de Óculos - OS-1054 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 1590,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-55",
    "date": "2026-02-12",
    "description": "Venda de Óculos - OS-1055 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 1023,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-56",
    "date": "2026-02-13",
    "description": "Venda de Óculos - OS-1056 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 1158,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-57",
    "date": "2026-02-13",
    "description": "Venda de Óculos - OS-1057 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 2120,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-58",
    "date": "2026-02-14",
    "description": "Venda de Óculos - OS-1058 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 1814,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-59",
    "date": "2026-02-14",
    "description": "Venda de Óculos - OS-1059 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 2092,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-60",
    "date": "2026-02-15",
    "description": "Venda de Óculos - OS-1060 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 878,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-61",
    "date": "2026-02-17",
    "description": "Venda de Óculos - OS-1061 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 894,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-62",
    "date": "2026-02-17",
    "description": "Venda de Óculos - OS-1062 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 969,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-63",
    "date": "2026-02-18",
    "description": "Venda de Óculos - OS-1063 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 725,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-64",
    "date": "2026-02-18",
    "description": "Venda de Óculos - OS-1064 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 2662,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-65",
    "date": "2026-02-19",
    "description": "Venda de Óculos - OS-1065 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 2149,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-66",
    "date": "2026-02-20",
    "description": "Venda de Óculos - OS-1066 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 2156,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-67",
    "date": "2026-02-20",
    "description": "Venda de Óculos - OS-1067 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 450,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-68",
    "date": "2026-02-21",
    "description": "Venda de Óculos - OS-1068 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 541,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-69",
    "date": "2026-02-21",
    "description": "Venda de Óculos - OS-1069 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 2531,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-70",
    "date": "2026-02-22",
    "description": "Venda de Óculos - OS-1070 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 863,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-71",
    "date": "2026-02-24",
    "description": "Venda de Óculos - OS-1071 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 2021,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-72",
    "date": "2026-02-24",
    "description": "Venda de Óculos - OS-1072 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 583,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-73",
    "date": "2026-02-25",
    "description": "Venda de Óculos - OS-1073 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2512,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-74",
    "date": "2026-02-25",
    "description": "Venda de Óculos - OS-1074 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2432,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-75",
    "date": "2026-02-26",
    "description": "Venda de Óculos - OS-1075 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1607,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-76",
    "date": "2026-02-27",
    "description": "Venda de Óculos - OS-1076 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 1533,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-77",
    "date": "2026-02-27",
    "description": "Venda de Óculos - OS-1077 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 1585,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-78",
    "date": "2026-02-28",
    "description": "Venda de Óculos - OS-1078 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 1761,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-79",
    "date": "2026-02-28",
    "description": "Venda de Óculos - OS-1079 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 2043,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-80",
    "date": "2026-03-01",
    "description": "Venda de Óculos - OS-1080 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 785,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-81",
    "date": "2026-03-03",
    "description": "Venda de Óculos - OS-1081 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 903,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-82",
    "date": "2026-03-03",
    "description": "Venda de Óculos - OS-1082 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 602,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-83",
    "date": "2026-03-04",
    "description": "Venda de Óculos - OS-1083 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 1620,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-84",
    "date": "2026-03-04",
    "description": "Venda de Óculos - OS-1084 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 1959,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-85",
    "date": "2026-03-05",
    "description": "Venda de Óculos - OS-1085 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1883,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-86",
    "date": "2026-03-06",
    "description": "Venda de Óculos - OS-1086 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 1061,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-87",
    "date": "2026-03-06",
    "description": "Venda de Óculos - OS-1087 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 177,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-88",
    "date": "2026-03-07",
    "description": "Venda de Óculos - OS-1088 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 474,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-89",
    "date": "2026-03-07",
    "description": "Venda de Óculos - OS-1089 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 693,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-90",
    "date": "2026-03-08",
    "description": "Venda de Óculos - OS-1090 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 1436,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-91",
    "date": "2026-03-10",
    "description": "Venda de Óculos - OS-1091 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 1989,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-92",
    "date": "2026-03-10",
    "description": "Venda de Óculos - OS-1092 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1664,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-93",
    "date": "2026-03-11",
    "description": "Venda de Óculos - OS-1093 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2687,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-94",
    "date": "2026-03-11",
    "description": "Venda de Óculos - OS-1094 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 1733,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-95",
    "date": "2026-03-12",
    "description": "Venda de Óculos - OS-1095 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 1224,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-96",
    "date": "2026-03-13",
    "description": "Venda de Óculos - OS-1096 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 2472,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-97",
    "date": "2026-03-13",
    "description": "Venda de Óculos - OS-1097 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 1646,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-98",
    "date": "2026-03-14",
    "description": "Venda de Óculos - OS-1098 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 2037,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-99",
    "date": "2026-03-14",
    "description": "Venda de Óculos - OS-1099 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 1684,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-100",
    "date": "2026-03-15",
    "description": "Venda de Óculos - OS-1100 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 441,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-101",
    "date": "2026-03-17",
    "description": "Venda de Óculos - OS-1101 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 1996,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-102",
    "date": "2026-03-17",
    "description": "Venda de Óculos - OS-1102 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 1165,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-103",
    "date": "2026-03-18",
    "description": "Venda de Óculos - OS-1103 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 1951,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-104",
    "date": "2026-03-18",
    "description": "Venda de Óculos - OS-1104 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 2083,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-105",
    "date": "2026-03-19",
    "description": "Venda de Óculos - OS-1105 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1408,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-106",
    "date": "2026-03-20",
    "description": "Venda de Óculos - OS-1106 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1951,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-107",
    "date": "2026-03-20",
    "description": "Venda de Óculos - OS-1107 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 1663,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-108",
    "date": "2026-03-21",
    "description": "Venda de Óculos - OS-1108 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 788,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-109",
    "date": "2026-03-21",
    "description": "Venda de Óculos - OS-1109 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1106,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-110",
    "date": "2026-03-22",
    "description": "Venda de Óculos - OS-1110 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 2452,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-111",
    "date": "2026-03-24",
    "description": "Venda de Óculos - OS-1111 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 282,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-112",
    "date": "2026-03-24",
    "description": "Venda de Óculos - OS-1112 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 944,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-113",
    "date": "2026-03-25",
    "description": "Venda de Óculos - OS-1113 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 314,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-114",
    "date": "2026-03-25",
    "description": "Venda de Óculos - OS-1114 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 2310,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-115",
    "date": "2026-03-26",
    "description": "Venda de Óculos - OS-1115 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1324,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-116",
    "date": "2026-03-27",
    "description": "Venda de Óculos - OS-1116 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 2471,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-117",
    "date": "2026-03-27",
    "description": "Venda de Óculos - OS-1117 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 1790,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-118",
    "date": "2026-03-28",
    "description": "Venda de Óculos - OS-1118 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 623,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-119",
    "date": "2026-03-28",
    "description": "Venda de Óculos - OS-1119 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 1448,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-120",
    "date": "2026-03-29",
    "description": "Venda de Óculos - OS-1120 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 557,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-121",
    "date": "2026-03-31",
    "description": "Venda de Óculos - OS-1121 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 609,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-122",
    "date": "2026-03-31",
    "description": "Venda de Óculos - OS-1122 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 1146,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-123",
    "date": "2026-04-01",
    "description": "Venda de Óculos - OS-1123 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 1152,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-124",
    "date": "2026-04-01",
    "description": "Venda de Óculos - OS-1124 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1307,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-125",
    "date": "2026-04-02",
    "description": "Venda de Óculos - OS-1125 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1207,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-126",
    "date": "2026-04-03",
    "description": "Venda de Óculos - OS-1126 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 2710,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-127",
    "date": "2026-04-03",
    "description": "Venda de Óculos - OS-1127 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 1227,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-128",
    "date": "2026-04-04",
    "description": "Venda de Óculos - OS-1128 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 1402,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-129",
    "date": "2026-04-04",
    "description": "Venda de Óculos - OS-1129 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 1094,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-130",
    "date": "2026-04-05",
    "description": "Venda de Óculos - OS-1130 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 2553,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-131",
    "date": "2026-04-07",
    "description": "Venda de Óculos - OS-1131 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 720,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-132",
    "date": "2026-04-07",
    "description": "Venda de Óculos - OS-1132 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 2315,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-133",
    "date": "2026-04-08",
    "description": "Venda de Óculos - OS-1133 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 1428,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-134",
    "date": "2026-04-08",
    "description": "Venda de Óculos - OS-1134 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 2001,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-135",
    "date": "2026-04-09",
    "description": "Venda de Óculos - OS-1135 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 1570,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-136",
    "date": "2026-04-10",
    "description": "Venda de Óculos - OS-1136 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 1384,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-137",
    "date": "2026-04-10",
    "description": "Venda de Óculos - OS-1137 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 1221,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-138",
    "date": "2026-04-11",
    "description": "Venda de Óculos - OS-1138 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 2102,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-139",
    "date": "2026-04-11",
    "description": "Venda de Óculos - OS-1139 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 940,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-140",
    "date": "2026-04-12",
    "description": "Venda de Óculos - OS-1140 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 1575,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-141",
    "date": "2026-04-14",
    "description": "Venda de Óculos - OS-1141 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 1061,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-142",
    "date": "2026-04-14",
    "description": "Venda de Óculos - OS-1142 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 2181,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-143",
    "date": "2026-04-15",
    "description": "Venda de Óculos - OS-1143 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2536,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-144",
    "date": "2026-04-15",
    "description": "Venda de Óculos - OS-1144 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 2366,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-145",
    "date": "2026-04-16",
    "description": "Venda de Óculos - OS-1145 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 1178,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-146",
    "date": "2026-04-17",
    "description": "Venda de Óculos - OS-1146 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 1626,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-147",
    "date": "2026-04-17",
    "description": "Venda de Óculos - OS-1147 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 2516,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-148",
    "date": "2026-04-18",
    "description": "Venda de Óculos - OS-1148 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 2660,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-149",
    "date": "2026-04-18",
    "description": "Venda de Óculos - OS-1149 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 2765,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-150",
    "date": "2026-04-19",
    "description": "Venda de Óculos - OS-1150 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 842,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-151",
    "date": "2026-04-21",
    "description": "Venda de Óculos - OS-1151 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1964,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-152",
    "date": "2026-04-21",
    "description": "Venda de Óculos - OS-1152 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 2363,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-153",
    "date": "2026-04-22",
    "description": "Venda de Óculos - OS-1153 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 1134,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-154",
    "date": "2026-04-22",
    "description": "Venda de Óculos - OS-1154 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 1290,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-155",
    "date": "2026-04-23",
    "description": "Venda de Óculos - OS-1155 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 2321,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-156",
    "date": "2026-04-24",
    "description": "Venda de Óculos - OS-1156 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2295,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-157",
    "date": "2026-04-24",
    "description": "Venda de Óculos - OS-1157 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 737,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-158",
    "date": "2026-04-25",
    "description": "Venda de Óculos - OS-1158 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2701,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-159",
    "date": "2026-04-25",
    "description": "Venda de Óculos - OS-1159 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 412,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-160",
    "date": "2026-04-26",
    "description": "Venda de Óculos - OS-1160 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1990,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-161",
    "date": "2026-04-28",
    "description": "Venda de Óculos - OS-1161 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2188,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-162",
    "date": "2026-04-28",
    "description": "Venda de Óculos - OS-1162 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 791,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-163",
    "date": "2026-04-29",
    "description": "Venda de Óculos - OS-1163 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 1905,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-164",
    "date": "2026-04-29",
    "description": "Venda de Óculos - OS-1164 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 517,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-165",
    "date": "2026-04-30",
    "description": "Venda de Óculos - OS-1165 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 2094,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-166",
    "date": "2026-05-01",
    "description": "Venda de Óculos - OS-1166 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 660,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-167",
    "date": "2026-05-01",
    "description": "Venda de Óculos - OS-1167 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 2582,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-168",
    "date": "2026-05-02",
    "description": "Venda de Óculos - OS-1168 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2161,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-169",
    "date": "2026-05-02",
    "description": "Venda de Óculos - OS-1169 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 750,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-170",
    "date": "2026-05-03",
    "description": "Venda de Óculos - OS-1170 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 704,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-171",
    "date": "2026-05-05",
    "description": "Venda de Óculos - OS-1171 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 2137,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-172",
    "date": "2026-05-05",
    "description": "Venda de Óculos - OS-1172 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 479,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-173",
    "date": "2026-05-06",
    "description": "Venda de Óculos - OS-1173 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 757,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-174",
    "date": "2026-05-06",
    "description": "Venda de Óculos - OS-1174 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 642,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-175",
    "date": "2026-05-07",
    "description": "Venda de Óculos - OS-1175 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 2628,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-176",
    "date": "2026-05-08",
    "description": "Venda de Óculos - OS-1176 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 2094,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-177",
    "date": "2026-05-08",
    "description": "Venda de Óculos - OS-1177 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 2439,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-178",
    "date": "2026-05-09",
    "description": "Venda de Óculos - OS-1178 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 705,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-179",
    "date": "2026-05-09",
    "description": "Venda de Óculos - OS-1179 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1972,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-180",
    "date": "2026-05-10",
    "description": "Venda de Óculos - OS-1180 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 2386,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-181",
    "date": "2026-05-12",
    "description": "Venda de Óculos - OS-1181 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 705,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-182",
    "date": "2026-05-12",
    "description": "Venda de Óculos - OS-1182 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 1941,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-183",
    "date": "2026-05-13",
    "description": "Venda de Óculos - OS-1183 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 2645,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-184",
    "date": "2026-05-13",
    "description": "Venda de Óculos - OS-1184 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 1200,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-185",
    "date": "2026-05-14",
    "description": "Venda de Óculos - OS-1185 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 1756,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-186",
    "date": "2026-05-15",
    "description": "Venda de Óculos - OS-1186 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 1245,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-187",
    "date": "2026-05-15",
    "description": "Venda de Óculos - OS-1187 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 901,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-188",
    "date": "2026-05-16",
    "description": "Venda de Óculos - OS-1188 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 1285,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-189",
    "date": "2026-05-16",
    "description": "Venda de Óculos - OS-1189 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 2597,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-190",
    "date": "2026-05-17",
    "description": "Venda de Óculos - OS-1190 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 1642,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-191",
    "date": "2026-05-19",
    "description": "Venda de Óculos - OS-1191 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 2213,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-192",
    "date": "2026-05-19",
    "description": "Venda de Óculos - OS-1192 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 1077,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-193",
    "date": "2026-05-20",
    "description": "Venda de Óculos - OS-1193 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 2790,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-194",
    "date": "2026-05-20",
    "description": "Venda de Óculos - OS-1194 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 805,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-195",
    "date": "2026-05-21",
    "description": "Venda de Óculos - OS-1195 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 957,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-196",
    "date": "2026-05-22",
    "description": "Venda de Óculos - OS-1196 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1673,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-197",
    "date": "2026-05-22",
    "description": "Venda de Óculos - OS-1197 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 750,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-198",
    "date": "2026-05-23",
    "description": "Venda de Óculos - OS-1198 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 2220,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-199",
    "date": "2026-05-23",
    "description": "Venda de Óculos - OS-1199 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 893,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-200",
    "date": "2026-05-24",
    "description": "Venda de Óculos - OS-1200 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 2376,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-201",
    "date": "2026-05-26",
    "description": "Venda de Óculos - OS-1201 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 1356,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-202",
    "date": "2026-05-26",
    "description": "Venda de Óculos - OS-1202 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 529,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-203",
    "date": "2026-05-27",
    "description": "Venda de Óculos - OS-1203 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 597,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-204",
    "date": "2026-05-27",
    "description": "Venda de Óculos - OS-1204 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 462,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-205",
    "date": "2026-05-28",
    "description": "Venda de Óculos - OS-1205 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 2026,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-206",
    "date": "2026-05-29",
    "description": "Venda de Óculos - OS-1206 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 2603,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-207",
    "date": "2026-05-29",
    "description": "Venda de Óculos - OS-1207 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2221,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-208",
    "date": "2026-05-30",
    "description": "Venda de Óculos - OS-1208 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 2112,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-209",
    "date": "2026-05-30",
    "description": "Venda de Óculos - OS-1209 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 2349,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-210",
    "date": "2026-05-31",
    "description": "Venda de Óculos - OS-1210 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 1986,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-211",
    "date": "2026-06-02",
    "description": "Venda de Óculos - OS-1211 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 2432,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-212",
    "date": "2026-06-02",
    "description": "Venda de Óculos - OS-1212 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1872,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-213",
    "date": "2026-06-03",
    "description": "Venda de Óculos - OS-1213 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 2327,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-214",
    "date": "2026-06-03",
    "description": "Venda de Óculos - OS-1214 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 1024,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-215",
    "date": "2026-06-04",
    "description": "Venda de Óculos - OS-1215 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 1390,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-216",
    "date": "2026-06-05",
    "description": "Venda de Óculos - OS-1216 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 2169,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-217",
    "date": "2026-06-05",
    "description": "Venda de Óculos - OS-1217 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 1366,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-218",
    "date": "2026-06-06",
    "description": "Venda de Óculos - OS-1218 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 2395,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-219",
    "date": "2026-06-06",
    "description": "Venda de Óculos - OS-1219 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 2501,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-220",
    "date": "2026-06-07",
    "description": "Venda de Óculos - OS-1220 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 1189,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-221",
    "date": "2026-06-09",
    "description": "Venda de Óculos - OS-1221 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 2188,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-222",
    "date": "2026-06-09",
    "description": "Venda de Óculos - OS-1222 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 2017,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-223",
    "date": "2026-06-10",
    "description": "Venda de Óculos - OS-1223 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 2702,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-224",
    "date": "2026-06-10",
    "description": "Venda de Óculos - OS-1224 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1481,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-225",
    "date": "2026-06-11",
    "description": "Venda de Óculos - OS-1225 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 513,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-226",
    "date": "2026-06-12",
    "description": "Venda de Óculos - OS-1226 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1097,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-227",
    "date": "2026-06-12",
    "description": "Venda de Óculos - OS-1227 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 1388,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-228",
    "date": "2026-06-13",
    "description": "Venda de Óculos - OS-1228 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 603,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-229",
    "date": "2026-06-13",
    "description": "Venda de Óculos - OS-1229 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 736,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-230",
    "date": "2026-06-14",
    "description": "Venda de Óculos - OS-1230 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2575,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-231",
    "date": "2026-06-16",
    "description": "Venda de Óculos - OS-1231 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 1963,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-232",
    "date": "2026-06-16",
    "description": "Venda de Óculos - OS-1232 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 551,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-233",
    "date": "2026-06-17",
    "description": "Venda de Óculos - OS-1233 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 1169,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-234",
    "date": "2026-06-17",
    "description": "Venda de Óculos - OS-1234 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 2785,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-235",
    "date": "2026-06-18",
    "description": "Venda de Óculos - OS-1235 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 1612,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-236",
    "date": "2026-06-19",
    "description": "Venda de Óculos - OS-1236 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 373,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-237",
    "date": "2026-06-19",
    "description": "Venda de Óculos - OS-1237 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 329,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-238",
    "date": "2026-06-20",
    "description": "Venda de Óculos - OS-1238 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 911,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-239",
    "date": "2026-06-20",
    "description": "Venda de Óculos - OS-1239 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 1081,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-240",
    "date": "2026-06-21",
    "description": "Venda de Óculos - OS-1240 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 2319,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-241",
    "date": "2026-06-23",
    "description": "Venda de Óculos - OS-1241 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 1392,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-242",
    "date": "2026-06-23",
    "description": "Venda de Óculos - OS-1242 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 1709,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-243",
    "date": "2026-06-24",
    "description": "Venda de Óculos - OS-1243 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1987,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-244",
    "date": "2026-06-24",
    "description": "Venda de Óculos - OS-1244 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 757,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-245",
    "date": "2026-06-25",
    "description": "Venda de Óculos - OS-1245 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 909,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-246",
    "date": "2026-06-26",
    "description": "Venda de Óculos - OS-1246 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 549,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-247",
    "date": "2026-06-26",
    "description": "Venda de Óculos - OS-1247 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 262,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-248",
    "date": "2026-06-27",
    "description": "Venda de Óculos - OS-1248 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 530,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-249",
    "date": "2026-06-27",
    "description": "Venda de Óculos - OS-1249 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 2640,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-250",
    "date": "2026-06-28",
    "description": "Venda de Óculos - OS-1250 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2585,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-251",
    "date": "2026-06-30",
    "description": "Venda de Óculos - OS-1251 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 2211,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-252",
    "date": "2026-06-30",
    "description": "Venda de Óculos - OS-1252 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 1843,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-253",
    "date": "2026-07-01",
    "description": "Venda de Óculos - OS-1253 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 917,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-254",
    "date": "2026-07-01",
    "description": "Venda de Óculos - OS-1254 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 2787,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-255",
    "date": "2026-07-02",
    "description": "Venda de Óculos - OS-1255 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 802,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-256",
    "date": "2026-07-03",
    "description": "Venda de Óculos - OS-1256 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2286,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-257",
    "date": "2026-07-03",
    "description": "Venda de Óculos - OS-1257 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 2341,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-258",
    "date": "2026-07-04",
    "description": "Venda de Óculos - OS-1258 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 1363,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-259",
    "date": "2026-07-04",
    "description": "Venda de Óculos - OS-1259 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 2472,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-260",
    "date": "2026-07-05",
    "description": "Venda de Óculos - OS-1260 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1020,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-261",
    "date": "2026-07-07",
    "description": "Venda de Óculos - OS-1261 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 1604,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-262",
    "date": "2026-07-07",
    "description": "Venda de Óculos - OS-1262 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 2044,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-263",
    "date": "2026-07-08",
    "description": "Venda de Óculos - OS-1263 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 438,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-264",
    "date": "2026-07-08",
    "description": "Venda de Óculos - OS-1264 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 1101,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-265",
    "date": "2026-07-09",
    "description": "Venda de Óculos - OS-1265 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 944,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-266",
    "date": "2026-07-10",
    "description": "Venda de Óculos - OS-1266 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 575,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-267",
    "date": "2026-07-10",
    "description": "Venda de Óculos - OS-1267 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 917,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-268",
    "date": "2026-07-11",
    "description": "Venda de Óculos - OS-1268 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 803,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-269",
    "date": "2026-07-11",
    "description": "Venda de Óculos - OS-1269 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 748,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-270",
    "date": "2026-07-12",
    "description": "Venda de Óculos - OS-1270 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 1466,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-271",
    "date": "2026-07-14",
    "description": "Venda de Óculos - OS-1271 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 1583,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-272",
    "date": "2026-07-14",
    "description": "Venda de Óculos - OS-1272 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 2495,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-273",
    "date": "2026-07-15",
    "description": "Venda de Óculos - OS-1273 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 914,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-274",
    "date": "2026-07-15",
    "description": "Venda de Óculos - OS-1274 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 779,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-275",
    "date": "2026-07-16",
    "description": "Venda de Óculos - OS-1275 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 718,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-276",
    "date": "2026-07-17",
    "description": "Venda de Óculos - OS-1276 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 2787,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-277",
    "date": "2026-07-17",
    "description": "Venda de Óculos - OS-1277 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 1179,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-278",
    "date": "2026-07-18",
    "description": "Venda de Óculos - OS-1278 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 1855,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-279",
    "date": "2026-07-18",
    "description": "Venda de Óculos - OS-1279 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1341,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-280",
    "date": "2026-07-19",
    "description": "Venda de Óculos - OS-1280 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 1560,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-281",
    "date": "2026-07-21",
    "description": "Venda de Óculos - OS-1281 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 813,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-282",
    "date": "2026-07-21",
    "description": "Venda de Óculos - OS-1282 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 832,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-283",
    "date": "2026-07-22",
    "description": "Venda de Óculos - OS-1283 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 1425,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-284",
    "date": "2026-07-22",
    "description": "Venda de Óculos - OS-1284 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 1227,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-285",
    "date": "2026-07-23",
    "description": "Venda de Óculos - OS-1285 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 1751,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-286",
    "date": "2026-07-24",
    "description": "Venda de Óculos - OS-1286 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 619,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-287",
    "date": "2026-07-24",
    "description": "Venda de Óculos - OS-1287 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1289,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-288",
    "date": "2026-07-25",
    "description": "Venda de Óculos - OS-1288 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 883,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-289",
    "date": "2026-07-25",
    "description": "Venda de Óculos - OS-1289 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 1056,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-290",
    "date": "2026-07-26",
    "description": "Venda de Óculos - OS-1290 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 2440,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-291",
    "date": "2026-07-28",
    "description": "Venda de Óculos - OS-1291 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1073,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-292",
    "date": "2026-07-28",
    "description": "Venda de Óculos - OS-1292 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 353,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-293",
    "date": "2026-07-29",
    "description": "Venda de Óculos - OS-1293 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 2081,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-294",
    "date": "2026-07-29",
    "description": "Venda de Óculos - OS-1294 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1439,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-295",
    "date": "2026-07-30",
    "description": "Venda de Óculos - OS-1295 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 1517,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-296",
    "date": "2026-07-31",
    "description": "Venda de Óculos - OS-1296 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 622,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-297",
    "date": "2026-07-31",
    "description": "Venda de Óculos - OS-1297 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 2529,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-298",
    "date": "2026-08-01",
    "description": "Venda de Óculos - OS-1298 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 2746,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-299",
    "date": "2026-08-01",
    "description": "Venda de Óculos - OS-1299 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 1928,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-300",
    "date": "2026-08-02",
    "description": "Venda de Óculos - OS-1300 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 1714,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-301",
    "date": "2026-08-04",
    "description": "Venda de Óculos - OS-1301 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 478,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-302",
    "date": "2026-08-04",
    "description": "Venda de Óculos - OS-1302 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 691,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-303",
    "date": "2026-08-05",
    "description": "Venda de Óculos - OS-1303 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 611,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-304",
    "date": "2026-08-05",
    "description": "Venda de Óculos - OS-1304 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 1333,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-305",
    "date": "2026-08-06",
    "description": "Venda de Óculos - OS-1305 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 2006,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-306",
    "date": "2026-08-07",
    "description": "Venda de Óculos - OS-1306 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 1246,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-307",
    "date": "2026-08-07",
    "description": "Venda de Óculos - OS-1307 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1177,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-308",
    "date": "2026-08-08",
    "description": "Venda de Óculos - OS-1308 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 1386,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-309",
    "date": "2026-08-08",
    "description": "Venda de Óculos - OS-1309 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 2548,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-310",
    "date": "2026-08-09",
    "description": "Venda de Óculos - OS-1310 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 226,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-311",
    "date": "2026-08-11",
    "description": "Venda de Óculos - OS-1311 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 305,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-312",
    "date": "2026-08-11",
    "description": "Venda de Óculos - OS-1312 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 771,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-313",
    "date": "2026-08-12",
    "description": "Venda de Óculos - OS-1313 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 820,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-314",
    "date": "2026-08-12",
    "description": "Venda de Óculos - OS-1314 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1385,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-315",
    "date": "2026-08-13",
    "description": "Venda de Óculos - OS-1315 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 1568,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-316",
    "date": "2026-08-14",
    "description": "Venda de Óculos - OS-1316 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 2399,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-317",
    "date": "2026-08-14",
    "description": "Venda de Óculos - OS-1317 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 2110,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-318",
    "date": "2026-08-15",
    "description": "Venda de Óculos - OS-1318 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 1380,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-319",
    "date": "2026-08-15",
    "description": "Venda de Óculos - OS-1319 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 445,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-320",
    "date": "2026-08-16",
    "description": "Venda de Óculos - OS-1320 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1192,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-321",
    "date": "2026-08-18",
    "description": "Venda de Óculos - OS-1321 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 1023,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-322",
    "date": "2026-08-18",
    "description": "Venda de Óculos - OS-1322 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 2405,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-323",
    "date": "2026-08-19",
    "description": "Venda de Óculos - OS-1323 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 410,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-324",
    "date": "2026-08-19",
    "description": "Venda de Óculos - OS-1324 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 412,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-325",
    "date": "2026-08-20",
    "description": "Venda de Óculos - OS-1325 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 1821,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-326",
    "date": "2026-08-21",
    "description": "Venda de Óculos - OS-1326 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 922,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-327",
    "date": "2026-08-21",
    "description": "Venda de Óculos - OS-1327 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 930,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-328",
    "date": "2026-08-22",
    "description": "Venda de Óculos - OS-1328 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 919,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-329",
    "date": "2026-08-22",
    "description": "Venda de Óculos - OS-1329 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 566,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-330",
    "date": "2026-08-23",
    "description": "Venda de Óculos - OS-1330 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 1333,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-331",
    "date": "2026-08-25",
    "description": "Venda de Óculos - OS-1331 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 252,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-332",
    "date": "2026-08-25",
    "description": "Venda de Óculos - OS-1332 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 466,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-333",
    "date": "2026-08-26",
    "description": "Venda de Óculos - OS-1333 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 707,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-334",
    "date": "2026-08-26",
    "description": "Venda de Óculos - OS-1334 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 908,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-335",
    "date": "2026-08-27",
    "description": "Venda de Óculos - OS-1335 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 1952,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-336",
    "date": "2026-08-28",
    "description": "Venda de Óculos - OS-1336 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 849,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-337",
    "date": "2026-08-28",
    "description": "Venda de Óculos - OS-1337 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 936,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-338",
    "date": "2026-08-29",
    "description": "Venda de Óculos - OS-1338 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 588,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-339",
    "date": "2026-08-29",
    "description": "Venda de Óculos - OS-1339 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2433,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-340",
    "date": "2026-08-30",
    "description": "Venda de Óculos - OS-1340 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 2279,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-341",
    "date": "2026-09-01",
    "description": "Venda de Óculos - OS-1341 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 639,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-342",
    "date": "2026-09-01",
    "description": "Venda de Óculos - OS-1342 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 2579,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-343",
    "date": "2026-09-02",
    "description": "Venda de Óculos - OS-1343 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 1467,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-344",
    "date": "2026-09-02",
    "description": "Venda de Óculos - OS-1344 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 1500,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-345",
    "date": "2026-09-03",
    "description": "Venda de Óculos - OS-1345 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 1515,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-346",
    "date": "2026-09-04",
    "description": "Venda de Óculos - OS-1346 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 1229,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-347",
    "date": "2026-09-04",
    "description": "Venda de Óculos - OS-1347 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 1210,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-348",
    "date": "2026-09-05",
    "description": "Venda de Óculos - OS-1348 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 1315,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-349",
    "date": "2026-09-05",
    "description": "Venda de Óculos - OS-1349 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 2587,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-350",
    "date": "2026-09-06",
    "description": "Venda de Óculos - OS-1350 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 496,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-351",
    "date": "2026-09-08",
    "description": "Venda de Óculos - OS-1351 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 842,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-352",
    "date": "2026-09-08",
    "description": "Venda de Óculos - OS-1352 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 495,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-353",
    "date": "2026-09-09",
    "description": "Venda de Óculos - OS-1353 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 2377,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-354",
    "date": "2026-09-09",
    "description": "Venda de Óculos - OS-1354 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 1279,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-355",
    "date": "2026-09-10",
    "description": "Venda de Óculos - OS-1355 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1929,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-356",
    "date": "2026-09-11",
    "description": "Venda de Óculos - OS-1356 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 1397,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-357",
    "date": "2026-09-11",
    "description": "Venda de Óculos - OS-1357 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 514,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-358",
    "date": "2026-09-12",
    "description": "Venda de Óculos - OS-1358 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 1630,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-359",
    "date": "2026-09-12",
    "description": "Venda de Óculos - OS-1359 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 738,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-360",
    "date": "2026-09-13",
    "description": "Venda de Óculos - OS-1360 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1701,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-361",
    "date": "2026-09-15",
    "description": "Venda de Óculos - OS-1361 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1687,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-362",
    "date": "2026-09-15",
    "description": "Venda de Óculos - OS-1362 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 2179,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-363",
    "date": "2026-09-16",
    "description": "Venda de Óculos - OS-1363 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 2449,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-364",
    "date": "2026-09-16",
    "description": "Venda de Óculos - OS-1364 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1493,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-365",
    "date": "2026-09-17",
    "description": "Venda de Óculos - OS-1365 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 1579,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-366",
    "date": "2026-09-18",
    "description": "Venda de Óculos - OS-1366 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 1686,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-367",
    "date": "2026-09-18",
    "description": "Venda de Óculos - OS-1367 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 1985,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-368",
    "date": "2026-09-19",
    "description": "Venda de Óculos - OS-1368 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 305,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-369",
    "date": "2026-09-19",
    "description": "Venda de Óculos - OS-1369 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 458,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-370",
    "date": "2026-09-20",
    "description": "Venda de Óculos - OS-1370 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 1491,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-371",
    "date": "2026-09-22",
    "description": "Venda de Óculos - OS-1371 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 692,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-372",
    "date": "2026-09-22",
    "description": "Venda de Óculos - OS-1372 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 1213,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-373",
    "date": "2026-09-23",
    "description": "Venda de Óculos - OS-1373 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 1403,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-374",
    "date": "2026-09-23",
    "description": "Venda de Óculos - OS-1374 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 1873,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-375",
    "date": "2026-09-24",
    "description": "Venda de Óculos - OS-1375 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 2654,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-376",
    "date": "2026-09-25",
    "description": "Venda de Óculos - OS-1376 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 1127,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-377",
    "date": "2026-09-25",
    "description": "Venda de Óculos - OS-1377 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 1587,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-378",
    "date": "2026-09-26",
    "description": "Venda de Óculos - OS-1378 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 1140,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-379",
    "date": "2026-09-26",
    "description": "Venda de Óculos - OS-1379 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 911,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-380",
    "date": "2026-09-27",
    "description": "Venda de Óculos - OS-1380 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1425,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-381",
    "date": "2026-09-29",
    "description": "Venda de Óculos - OS-1381 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1916,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-382",
    "date": "2026-09-29",
    "description": "Venda de Óculos - OS-1382 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 1338,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-383",
    "date": "2026-09-30",
    "description": "Venda de Óculos - OS-1383 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 1038,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-384",
    "date": "2026-09-30",
    "description": "Venda de Óculos - OS-1384 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 1336,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-385",
    "date": "2026-10-01",
    "description": "Venda de Óculos - OS-1385 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 457,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-386",
    "date": "2026-10-02",
    "description": "Venda de Óculos - OS-1386 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 1991,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-387",
    "date": "2026-10-02",
    "description": "Venda de Óculos - OS-1387 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 2406,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-388",
    "date": "2026-10-03",
    "description": "Venda de Óculos - OS-1388 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 2159,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-389",
    "date": "2026-10-03",
    "description": "Venda de Óculos - OS-1389 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2614,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-390",
    "date": "2026-10-04",
    "description": "Venda de Óculos - OS-1390 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2384,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-391",
    "date": "2026-10-06",
    "description": "Venda de Óculos - OS-1391 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 625,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-392",
    "date": "2026-10-06",
    "description": "Venda de Óculos - OS-1392 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 737,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-393",
    "date": "2026-10-07",
    "description": "Venda de Óculos - OS-1393 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 1024,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-394",
    "date": "2026-10-07",
    "description": "Venda de Óculos - OS-1394 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 980,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-395",
    "date": "2026-10-08",
    "description": "Venda de Óculos - OS-1395 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 2126,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-396",
    "date": "2026-10-09",
    "description": "Venda de Óculos - OS-1396 - Juliana Ferreira Costa",
    "type": "IN",
    "category": "SALES",
    "amount": 1221,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-397",
    "date": "2026-10-09",
    "description": "Venda de Óculos - OS-1397 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 645,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-398",
    "date": "2026-10-10",
    "description": "Venda de Óculos - OS-1398 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 1413,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-399",
    "date": "2026-10-10",
    "description": "Venda de Óculos - OS-1399 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 828,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-400",
    "date": "2026-10-11",
    "description": "Venda de Óculos - OS-1400 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 1315,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-401",
    "date": "2026-10-13",
    "description": "Venda de Óculos - OS-1401 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 1009,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-402",
    "date": "2026-10-13",
    "description": "Venda de Óculos - OS-1402 - Ana Clara Albuquerque",
    "type": "IN",
    "category": "SALES",
    "amount": 2197,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-403",
    "date": "2026-10-14",
    "description": "Venda de Óculos - OS-1403 - Camila Torres Rodrigues",
    "type": "IN",
    "category": "SALES",
    "amount": 1578,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-404",
    "date": "2026-10-14",
    "description": "Venda de Óculos - OS-1404 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 791,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-405",
    "date": "2026-10-15",
    "description": "Venda de Óculos - OS-1405 - Patricia Alves Nunes",
    "type": "IN",
    "category": "SALES",
    "amount": 1400,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-406",
    "date": "2026-10-16",
    "description": "Venda de Óculos - OS-1406 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 901,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-407",
    "date": "2026-10-16",
    "description": "Venda de Óculos - OS-1407 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 1810,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-408",
    "date": "2026-10-17",
    "description": "Venda de Óculos - OS-1408 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 660,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-409",
    "date": "2026-10-17",
    "description": "Venda de Óculos - OS-1409 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2290,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-410",
    "date": "2026-10-18",
    "description": "Venda de Óculos - OS-1410 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 2359,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-411",
    "date": "2026-10-20",
    "description": "Venda de Óculos - OS-1411 - Marcos Antonio Barbosa",
    "type": "IN",
    "category": "SALES",
    "amount": 1457,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-412",
    "date": "2026-10-20",
    "description": "Venda de Óculos - OS-1412 - Roberto Souza Mendes",
    "type": "IN",
    "category": "SALES",
    "amount": 584,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-413",
    "date": "2026-10-21",
    "description": "Venda de Óculos - OS-1413 - Diego Henrique Pereira",
    "type": "IN",
    "category": "SALES",
    "amount": 1996,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-414",
    "date": "2026-10-21",
    "description": "Venda de Óculos - OS-1414 - Larissa Monteiro Campos",
    "type": "IN",
    "category": "SALES",
    "amount": 2231,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-415",
    "date": "2026-10-22",
    "description": "Venda de Óculos - OS-1415 - Fernando Augusto Lima",
    "type": "IN",
    "category": "SALES",
    "amount": 1259,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-416",
    "date": "2026-10-23",
    "description": "Venda de Óculos - OS-1416 - Carlos Eduardo Oliveira",
    "type": "IN",
    "category": "SALES",
    "amount": 453,
    "status": "PAID",
    "paymentMethod": "CREDIT"
  },
  {
    "id": "tx-417",
    "date": "2026-10-23",
    "description": "Venda de Óculos - OS-1417 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 1334,
    "status": "PAID",
    "paymentMethod": "CASH"
  },
  {
    "id": "tx-418",
    "date": "2026-10-24",
    "description": "Venda de Óculos - OS-1418 - Rafael Carvalho Gomes",
    "type": "IN",
    "category": "SALES",
    "amount": 1109,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-419",
    "date": "2026-10-24",
    "description": "Venda de Óculos - OS-1419 - Beatriz Martins Santos",
    "type": "IN",
    "category": "SALES",
    "amount": 773,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-420",
    "date": "2026-01-05",
    "description": "Aluguel Ponto Comercial - 2026-01",
    "type": "OUT",
    "category": "RENT",
    "amount": 2800,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-421",
    "date": "2026-01-05",
    "description": "Folha de Pagamento - 2026-01",
    "type": "OUT",
    "category": "SALARY",
    "amount": 10750,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-422",
    "date": "2026-01-10",
    "description": "Fatura Laboratório Central Vision - 2026-01",
    "type": "OUT",
    "category": "SUPPLIER",
    "amount": 6086,
    "status": "PAID",
    "paymentMethod": "BOLETO"
  },
  {
    "id": "tx-423",
    "date": "2026-01-20",
    "description": "Energia + Internet + Telefone - 2026-01",
    "type": "OUT",
    "category": "UTILITIES",
    "amount": 968,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-424",
    "date": "2026-02-05",
    "description": "Aluguel Ponto Comercial - 2026-02",
    "type": "OUT",
    "category": "RENT",
    "amount": 2800,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-425",
    "date": "2026-02-05",
    "description": "Folha de Pagamento - 2026-02",
    "type": "OUT",
    "category": "SALARY",
    "amount": 10320,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-426",
    "date": "2026-02-10",
    "description": "Fatura Laboratório Central Vision - 2026-02",
    "type": "OUT",
    "category": "SUPPLIER",
    "amount": 4425,
    "status": "PAID",
    "paymentMethod": "BOLETO"
  },
  {
    "id": "tx-427",
    "date": "2026-02-20",
    "description": "Energia + Internet + Telefone - 2026-02",
    "type": "OUT",
    "category": "UTILITIES",
    "amount": 938,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-428",
    "date": "2026-03-05",
    "description": "Aluguel Ponto Comercial - 2026-03",
    "type": "OUT",
    "category": "RENT",
    "amount": 2800,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-429",
    "date": "2026-03-05",
    "description": "Folha de Pagamento - 2026-03",
    "type": "OUT",
    "category": "SALARY",
    "amount": 9315,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-430",
    "date": "2026-03-10",
    "description": "Fatura Laboratório Central Vision - 2026-03",
    "type": "OUT",
    "category": "SUPPLIER",
    "amount": 6016,
    "status": "PAID",
    "paymentMethod": "BOLETO"
  },
  {
    "id": "tx-431",
    "date": "2026-03-20",
    "description": "Energia + Internet + Telefone - 2026-03",
    "type": "OUT",
    "category": "UTILITIES",
    "amount": 661,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-432",
    "date": "2026-04-05",
    "description": "Aluguel Ponto Comercial - 2026-04",
    "type": "OUT",
    "category": "RENT",
    "amount": 2800,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-433",
    "date": "2026-04-05",
    "description": "Folha de Pagamento - 2026-04",
    "type": "OUT",
    "category": "SALARY",
    "amount": 8646,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-434",
    "date": "2026-04-10",
    "description": "Fatura Laboratório Central Vision - 2026-04",
    "type": "OUT",
    "category": "SUPPLIER",
    "amount": 6093,
    "status": "PAID",
    "paymentMethod": "BOLETO"
  },
  {
    "id": "tx-435",
    "date": "2026-04-20",
    "description": "Energia + Internet + Telefone - 2026-04",
    "type": "OUT",
    "category": "UTILITIES",
    "amount": 925,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-436",
    "date": "2026-05-05",
    "description": "Aluguel Ponto Comercial - 2026-05",
    "type": "OUT",
    "category": "RENT",
    "amount": 2800,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-437",
    "date": "2026-05-05",
    "description": "Folha de Pagamento - 2026-05",
    "type": "OUT",
    "category": "SALARY",
    "amount": 10660,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-438",
    "date": "2026-05-10",
    "description": "Fatura Laboratório Central Vision - 2026-05",
    "type": "OUT",
    "category": "SUPPLIER",
    "amount": 4015,
    "status": "PAID",
    "paymentMethod": "BOLETO"
  },
  {
    "id": "tx-439",
    "date": "2026-05-20",
    "description": "Energia + Internet + Telefone - 2026-05",
    "type": "OUT",
    "category": "UTILITIES",
    "amount": 1010,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-440",
    "date": "2026-06-05",
    "description": "Aluguel Ponto Comercial - 2026-06",
    "type": "OUT",
    "category": "RENT",
    "amount": 2800,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-441",
    "date": "2026-06-05",
    "description": "Folha de Pagamento - 2026-06",
    "type": "OUT",
    "category": "SALARY",
    "amount": 8996,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-442",
    "date": "2026-06-10",
    "description": "Fatura Laboratório Central Vision - 2026-06",
    "type": "OUT",
    "category": "SUPPLIER",
    "amount": 6140,
    "status": "PAID",
    "paymentMethod": "BOLETO"
  },
  {
    "id": "tx-443",
    "date": "2026-06-20",
    "description": "Energia + Internet + Telefone - 2026-06",
    "type": "OUT",
    "category": "UTILITIES",
    "amount": 913,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-444",
    "date": "2026-07-05",
    "description": "Aluguel Ponto Comercial - 2026-07",
    "type": "OUT",
    "category": "RENT",
    "amount": 2800,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-445",
    "date": "2026-07-05",
    "description": "Folha de Pagamento - 2026-07",
    "type": "OUT",
    "category": "SALARY",
    "amount": 10145,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-446",
    "date": "2026-07-10",
    "description": "Fatura Laboratório Central Vision - 2026-07",
    "type": "OUT",
    "category": "SUPPLIER",
    "amount": 6165,
    "status": "PAID",
    "paymentMethod": "BOLETO"
  },
  {
    "id": "tx-447",
    "date": "2026-07-20",
    "description": "Energia + Internet + Telefone - 2026-07",
    "type": "OUT",
    "category": "UTILITIES",
    "amount": 976,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-448",
    "date": "2026-08-05",
    "description": "Aluguel Ponto Comercial - 2026-08",
    "type": "OUT",
    "category": "RENT",
    "amount": 2800,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-449",
    "date": "2026-08-05",
    "description": "Folha de Pagamento - 2026-08",
    "type": "OUT",
    "category": "SALARY",
    "amount": 8884,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-450",
    "date": "2026-08-10",
    "description": "Fatura Laboratório Central Vision - 2026-08",
    "type": "OUT",
    "category": "SUPPLIER",
    "amount": 6152,
    "status": "PAID",
    "paymentMethod": "BOLETO"
  },
  {
    "id": "tx-451",
    "date": "2026-08-20",
    "description": "Energia + Internet + Telefone - 2026-08",
    "type": "OUT",
    "category": "UTILITIES",
    "amount": 870,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-452",
    "date": "2026-09-05",
    "description": "Aluguel Ponto Comercial - 2026-09",
    "type": "OUT",
    "category": "RENT",
    "amount": 2800,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-453",
    "date": "2026-09-05",
    "description": "Folha de Pagamento - 2026-09",
    "type": "OUT",
    "category": "SALARY",
    "amount": 8574,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-454",
    "date": "2026-09-10",
    "description": "Fatura Laboratório Central Vision - 2026-09",
    "type": "OUT",
    "category": "SUPPLIER",
    "amount": 4544,
    "status": "PAID",
    "paymentMethod": "BOLETO"
  },
  {
    "id": "tx-455",
    "date": "2026-09-20",
    "description": "Energia + Internet + Telefone - 2026-09",
    "type": "OUT",
    "category": "UTILITIES",
    "amount": 922,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  },
  {
    "id": "tx-456",
    "date": "2026-10-05",
    "description": "Aluguel Ponto Comercial - 2026-10",
    "type": "OUT",
    "category": "RENT",
    "amount": 2800,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-457",
    "date": "2026-10-05",
    "description": "Folha de Pagamento - 2026-10",
    "type": "OUT",
    "category": "SALARY",
    "amount": 9202,
    "status": "PAID",
    "paymentMethod": "PIX"
  },
  {
    "id": "tx-458",
    "date": "2026-10-10",
    "description": "Fatura Laboratório Central Vision - 2026-10",
    "type": "OUT",
    "category": "SUPPLIER",
    "amount": 4334,
    "status": "PAID",
    "paymentMethod": "BOLETO"
  },
  {
    "id": "tx-459",
    "date": "2026-10-20",
    "description": "Energia + Internet + Telefone - 2026-10",
    "type": "OUT",
    "category": "UTILITIES",
    "amount": 681,
    "status": "PAID",
    "paymentMethod": "DEBIT"
  }
];
